<template>
<div class="bg-light border-right" id="sidebar-wrapper">
  <div class="sidebar-heading">
    <a class="navbar-brand brand-logo" @click="toPage('/')" href=""><img src="~@/assets/images/logo-new.png" alt="logo" class="brand-logo" /></a>
  </div>
  <div class="list-group list-group-flush">
    <div class="accordion" id="accordionExample">
      <a class="list-group-item list-group-item-action bg-light link active" @click="toPage('/dashboard')" v-if="route === 'dashboard' && viewDashboard === true"> <i class="fas fa-home"></i> <span class="menu-title"> Dashboard </span></a>
      <a class="list-group-item list-group-item-action bg-light link" @click="toPage('/dashboard')" v-else-if="route != 'dashboard' && viewDashboard === true"> <i class="fas fa-home"></i> <span class="menu-title"> Dashboard </span></a>
      <!-- SECTION - Start Menu Rental -->
      <div v-if="viewOrder === true"  id="headingRental">  
        <a href="#" class="list-group-item list-group-item-action bg-light d-flex" :class="{'active border-bottom border-primary': showOrderSubItem}" data-toggle="collapse" aria-expanded="true" data-target="#collapseOrder" aria-controls="collapseOrder"
        > <span class="order-icon"></span><i class="fas fa-clipboard-list"></i> <span class="menu-title-order"> Rental </span>
            <div class="right-arrow"><span class="badge badge-danger badge-order" v-if="rentalCount != '0'">{{ rentalCount }}</span><i class="fas fa-angle-down"></i></div>
        </a>
      </div>
      <div class="collapse" :class="{'show': showOrderSubItem}" id="collapseOrder" aria-labelledby="headingRental" data-parent="#accordionExample" v-if="viewOrder === true">
        <ul>
          <li class="sidebar link" v-if="permission.includes('2.1')"><a @click="toOrderPage" class="d-flex align-items-center">Order<span class="badge badge-danger badge-order p-1 mb-1 ml-2" v-if="orderCount != '0'">{{ orderCount }}</span></a></li>
          <li class="sidebar link" v-if="permission.includes('13.1')"><a @click="toRentalProductPage" class="d-flex align-items-center">Product<span class="badge badge-danger badge-order p-1 mb-1 ml-2" v-if="productCount != '0'">{{ productCount }}</span></a></li>
          <component-guard :requiredPermissions="['27.1']">
            <li class="sidebar link"><a @click="toTransferUnitPage" class="d-flex align-items-center">Pembaruan Order <span class="badge badge-danger badge-order p-1 mb-1 ml-2" v-if="rentAdjustmentCount != '0'">{{ rentAdjustmentCount }}</span></a></li>
          </component-guard>
          <li class="sidebar link" v-if="permission.includes('2.6')"><a @click="toRentalUpgrade">Upgrade / Downgrade Unit</a></li>
          <li class="sidebar link" v-if="permission.includes('2.7')"><a @click="toLostItemPage">Lost Item</a></li>
          <!-- <li class="sidebar link"><a @click="toPage('/order/tracking/renting')">Tracking</a></li> -->
        </ul>
      </div>
      <!-- !SECTION - End Menu Rental -->

      <a href="#" class="list-group-item list-group-item-action bg-light d-flex active" data-toggle="collapse" data-target="#collapseCatalog" v-if="route.includes('catalog') && (viewSparepart === true || viewProduct === true)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" :fill="$route.path.includes('/catalog') ? '#5A9AE8' : '#38485C'">
          <path d="M14.4616 1.413C9.56939 3.47 6.72626 6.418 6.58225 6.57C6.19324 6.979 5.89122 7.478 5.77022 8.052C5.73922 8.194 4.99918 11.568 4.99918 14.999C4.99918 15.913 5.05318 16.822 5.13119 17.67C3.64212 17.466 2.59507 17.239 2.53507 17.226C2.15405 17.142 1.85604 16.845 1.77304 16.464C1.74103 16.319 1 12.902 1 9.499C1 6.096 1.74203 2.678 1.77304 2.535C1.85604 2.154 2.15405 1.856 2.53507 1.773C2.67908 1.741 6.09723 1 9.49939 1C11.3185 1 13.1366 1.211 14.4616 1.413ZM14.9996 4.999C15.9147 4.999 16.8237 5.052 17.6708 5.13C17.4657 3.639 17.2387 2.593 17.2257 2.534C17.2257 2.532 17.2237 2.53 17.2237 2.527C14.9426 3.258 13.0205 4.262 11.5355 5.211C12.5915 5.091 13.7906 4.999 14.9996 4.999ZM23 14.999C23 18.183 22.306 21.379 22.276 21.514C22.193 21.895 21.8949 22.192 21.5139 22.276C21.3799 22.305 18.1828 23 14.9996 23C11.8165 23 8.61935 22.306 8.48534 22.276C8.10432 22.192 7.80631 21.895 7.72331 21.514C7.6933 21.379 6.99927 18.183 6.99927 14.999C6.99927 11.815 7.6933 8.619 7.72331 8.485C7.80631 8.104 8.10432 7.806 8.48534 7.723C8.61935 7.693 11.8165 6.999 14.9996 6.999C18.1828 6.999 21.3799 7.693 21.5139 7.723C21.8949 7.806 22.193 8.104 22.276 8.485C22.306 8.619 23 11.816 23 14.999ZM13.9996 17.999C13.9996 17.462 13.8886 16.941 13.8756 16.884C13.7926 16.503 13.4946 16.205 13.1125 16.122C13.0555 16.109 12.5365 15.999 11.9995 15.999C11.4625 15.999 10.9435 16.109 10.8864 16.122C10.5044 16.205 10.2064 16.503 10.1234 16.884C10.1104 16.942 9.99941 17.462 9.99941 17.999C9.99941 18.536 10.1104 19.057 10.1234 19.114C10.2064 19.495 10.5044 19.793 10.8864 19.876C10.9435 19.889 11.4625 19.999 11.9995 19.999C12.5365 19.999 13.0555 19.889 13.1125 19.876C13.4946 19.793 13.7926 19.495 13.8756 19.114C13.8886 19.056 13.9996 18.536 13.9996 17.999ZM13.9996 11.999C13.9996 11.461 13.8886 10.942 13.8756 10.885C13.7926 10.504 13.4946 10.206 13.1136 10.123C13.0565 10.11 12.5365 9.999 11.9995 9.999C11.4625 9.999 10.9425 10.11 10.8854 10.123C10.5044 10.206 10.2064 10.504 10.1234 10.885C10.1104 10.942 9.99941 11.462 9.99941 11.999C9.99941 12.536 10.1104 13.056 10.1234 13.113C10.2064 13.494 10.5044 13.792 10.8854 13.876C10.9425 13.889 11.4625 13.999 11.9995 13.999C12.5365 13.999 13.0565 13.889 13.1136 13.876C13.4946 13.792 13.7926 13.494 13.8756 13.113C13.8886 13.055 13.9996 12.536 13.9996 11.999ZM19.9999 17.999C19.9999 17.446 19.5518 16.999 18.9998 16.999H15.9997C15.4477 16.999 14.9996 17.446 14.9996 17.999C14.9996 18.552 15.4477 18.999 15.9997 18.999H18.9998C19.5518 18.999 19.9999 18.552 19.9999 17.999ZM19.9999 11.999C19.9999 11.447 19.5518 10.999 18.9998 10.999H15.9997C15.4477 10.999 14.9996 11.447 14.9996 11.999C14.9996 12.551 15.4477 12.999 15.9997 12.999H18.9998C19.5518 12.999 19.9999 12.551 19.9999 11.999Z" :fill="$route.path.includes('/catalog') ? '#5A9AE8' : '#38485C'"/>
        </svg>
        <span class="menu-title">Catalog</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex" data-toggle="collapse" data-target="#collapseCatalog" v-else-if="!route.includes('catalog') && viewSparepart === true && viewProduct === true">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" :fill="$route.path.includes('/catalog') ? '#5A9AE8' : '#38485C'">
          <path d="M14.4616 1.413C9.56939 3.47 6.72626 6.418 6.58225 6.57C6.19324 6.979 5.89122 7.478 5.77022 8.052C5.73922 8.194 4.99918 11.568 4.99918 14.999C4.99918 15.913 5.05318 16.822 5.13119 17.67C3.64212 17.466 2.59507 17.239 2.53507 17.226C2.15405 17.142 1.85604 16.845 1.77304 16.464C1.74103 16.319 1 12.902 1 9.499C1 6.096 1.74203 2.678 1.77304 2.535C1.85604 2.154 2.15405 1.856 2.53507 1.773C2.67908 1.741 6.09723 1 9.49939 1C11.3185 1 13.1366 1.211 14.4616 1.413ZM14.9996 4.999C15.9147 4.999 16.8237 5.052 17.6708 5.13C17.4657 3.639 17.2387 2.593 17.2257 2.534C17.2257 2.532 17.2237 2.53 17.2237 2.527C14.9426 3.258 13.0205 4.262 11.5355 5.211C12.5915 5.091 13.7906 4.999 14.9996 4.999ZM23 14.999C23 18.183 22.306 21.379 22.276 21.514C22.193 21.895 21.8949 22.192 21.5139 22.276C21.3799 22.305 18.1828 23 14.9996 23C11.8165 23 8.61935 22.306 8.48534 22.276C8.10432 22.192 7.80631 21.895 7.72331 21.514C7.6933 21.379 6.99927 18.183 6.99927 14.999C6.99927 11.815 7.6933 8.619 7.72331 8.485C7.80631 8.104 8.10432 7.806 8.48534 7.723C8.61935 7.693 11.8165 6.999 14.9996 6.999C18.1828 6.999 21.3799 7.693 21.5139 7.723C21.8949 7.806 22.193 8.104 22.276 8.485C22.306 8.619 23 11.816 23 14.999ZM13.9996 17.999C13.9996 17.462 13.8886 16.941 13.8756 16.884C13.7926 16.503 13.4946 16.205 13.1125 16.122C13.0555 16.109 12.5365 15.999 11.9995 15.999C11.4625 15.999 10.9435 16.109 10.8864 16.122C10.5044 16.205 10.2064 16.503 10.1234 16.884C10.1104 16.942 9.99941 17.462 9.99941 17.999C9.99941 18.536 10.1104 19.057 10.1234 19.114C10.2064 19.495 10.5044 19.793 10.8864 19.876C10.9435 19.889 11.4625 19.999 11.9995 19.999C12.5365 19.999 13.0555 19.889 13.1125 19.876C13.4946 19.793 13.7926 19.495 13.8756 19.114C13.8886 19.056 13.9996 18.536 13.9996 17.999ZM13.9996 11.999C13.9996 11.461 13.8886 10.942 13.8756 10.885C13.7926 10.504 13.4946 10.206 13.1136 10.123C13.0565 10.11 12.5365 9.999 11.9995 9.999C11.4625 9.999 10.9425 10.11 10.8854 10.123C10.5044 10.206 10.2064 10.504 10.1234 10.885C10.1104 10.942 9.99941 11.462 9.99941 11.999C9.99941 12.536 10.1104 13.056 10.1234 13.113C10.2064 13.494 10.5044 13.792 10.8854 13.876C10.9425 13.889 11.4625 13.999 11.9995 13.999C12.5365 13.999 13.0565 13.889 13.1136 13.876C13.4946 13.792 13.7926 13.494 13.8756 13.113C13.8886 13.055 13.9996 12.536 13.9996 11.999ZM19.9999 17.999C19.9999 17.446 19.5518 16.999 18.9998 16.999H15.9997C15.4477 16.999 14.9996 17.446 14.9996 17.999C14.9996 18.552 15.4477 18.999 15.9997 18.999H18.9998C19.5518 18.999 19.9999 18.552 19.9999 17.999ZM19.9999 11.999C19.9999 11.447 19.5518 10.999 18.9998 10.999H15.9997C15.4477 10.999 14.9996 11.447 14.9996 11.999C14.9996 12.551 15.4477 12.999 15.9997 12.999H18.9998C19.5518 12.999 19.9999 12.551 19.9999 11.999Z" :fill="$route.path.includes('/catalog') ? '#5A9AE8' : '#38485C'"/>
        </svg>
        <span class="menu-title">Catalog</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <div id="collapseCatalog" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="route.includes('catalog') && (viewSparepart === true || viewProduct === true)">
        <ul>
          <!-- <li class="sidebar link" @click="toSparepartPage()" v-if="viewSparepart === true"><a>Sparepart</a></li> -->
          <li class="sidebar link" @click="toProductPage()" v-if="viewProduct === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path === '/catalog'  ? '#5A9AE8' : '#38485C'}`">
                Product
              </span>
            </a>
          </li>
          <li class="sidebar link" @click="toPartCompabilityPage()" v-if="viewPartCompatibility === true"><a>Part Compatibility</a></li>
          <li class="sidebar link" @click="toBatchNumberListPage()" v-if="viewBatchNumber === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path.includes('/batch-number-list') ? '#5A9AE8' : '#38485C'}`">
                Batch Number List
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div id="collapseCatalog" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else-if="!route.includes('catalog') && (viewSparepart === true || viewProduct === true)">
        <ul>
          <!-- <li class="sidebar link" @click="toSparepartPage()" v-if="viewSparepart === true"><a>Sparepart</a></li> -->
          <li class="sidebar link" @click="toProductPage()" v-if="viewProduct === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path ==='/catalog' ? '#5A9AE8' : '#38485C'}`">
                Product
              </span>
            </a>
          </li>
          <li class="sidebar link" @click="toPartCompabilityPage()" v-if="viewPartCompatibility === true"><a>Part Compatibility</a></li>
          <li class="sidebar link" @click="toBatchNumberListPage()" v-if="viewBatchNumber === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path.includes('/batch-number-list') ? '#5A9AE8' : '#38485C'}`">
                Batch Number List
              </span>
            </a>
          </li>
        </ul>
      </div>

      <a href="#" class="list-group-item list-group-item-action bg-light d-flex active" data-toggle="collapse" data-target="#collapsePurchase" v-if="(route.includes('purchase')) && viewPurchaseReceipt">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" :fill="$route.path.includes('/purchase') ? '#5A9AE8' : '#38485C'">
          <path d="M6 11V21C6 22.654 7.346 24 9 24H21C22.654 24 24 22.654 24 21V11H6ZM19 16C19 18.206 17.206 20 15 20C12.794 20 11 18.206 11 16V14H13V16C13 17.103 13.897 18 15 18C16.103 18 17 17.103 17 16V14H19V16ZM4 9H19V5H14V4.5C14 2.019 11.981 0 9.5 0C7.019 0 5 2.019 5 4.5V5H0V16C0 17.654 1.346 19 3 19H4V9ZM7 4.5C7 3.121 8.122 2 9.5 2C10.878 2 12 3.121 12 4.5V5H7V4.5Z" :fill="$route.path.includes('/purchase') ? '#5A9AE8' : '#38485C'"/>
        </svg>
        <span class="menu-title">Purchase</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex" data-toggle="collapse" data-target="#collapsePurchase" v-else-if="!route.includes('purchase') && viewPurchaseReceipt">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" :fill="$route.path.includes('/purchase') ? '#5A9AE8' : '#38485C'">>
          <path d="M6 11V21C6 22.654 7.346 24 9 24H21C22.654 24 24 22.654 24 21V11H6ZM19 16C19 18.206 17.206 20 15 20C12.794 20 11 18.206 11 16V14H13V16C13 17.103 13.897 18 15 18C16.103 18 17 17.103 17 16V14H19V16ZM4 9H19V5H14V4.5C14 2.019 11.981 0 9.5 0C7.019 0 5 2.019 5 4.5V5H0V16C0 17.654 1.346 19 3 19H4V9ZM7 4.5C7 3.121 8.122 2 9.5 2C10.878 2 12 3.121 12 4.5V5H7V4.5Z" :fill="$route.path.includes('/purchase') ? '#5A9AE8' : '#38485C'"/>
        </svg>
        <span class="menu-title">Purchase</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <div id="collapsePurchase" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="(route.includes('purchase')) && (viewSparepart === true || viewProduct === true)">
        <ul>
          <!-- <li class="sidebar link" @click="toSparepartPage()" v-if="viewSparepart === true"><a>Sparepart</a></li> -->
          <li class="sidebar link" @click="toPurchaseReceipt()" v-if="viewProduct === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path.includes('purchase/receipt') ? '#5A9AE8' : '#38485C'}`">
                Receipt
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div id="collapsePurchase" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else-if="!route.includes('purchase') && (viewSparepart === true || viewProduct === true)">
        <ul>
          <!-- <li class="sidebar link" @click="toSparepartPage()" v-if="viewSparepart === true"><a>Sparepart</a></li> -->
          <li class="sidebar link" @click="toPurchaseReceipt()" v-if="viewProduct === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path.includes('purchase/receipt') ? '#5A9AE8' : '#38485C'}`">
                Receipt
              </span>
            </a>
          </li>
        </ul>
      </div>

      <!--  <a class="list-group-item list-group-item-action bg-light link active" @click="toPage('/return/schedule')" v-if="route === 'return' && viewReturn === true"> <i class="fas fa-undo"></i> <span class="menu-title"> Return </span></a>
                <a class="list-group-item list-group-item-action bg-light link" @click="toPage('/return/schedule')" v-else-if="route != 'return' && viewReturn === true"> <i class="fas fa-undo"></i> <span class="menu-title"> Return </span></a> -->

    <!-- Warehouse Stock -->
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex active" data-toggle="collapse" data-target="#collapseStock" v-if="(route.includes('stock')) && (viewStock === true || viewStockSummary === true)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" :fill="$route.path.includes('/stock') ? '#5A9AE8' : '#38485C'">
          <path d="M23 9.91316V20.7084C23 21.9743 21.9743 23 20.7083 23C19.4424 23 18.4167 21.9743 18.4167 20.7084V12.0003C18.4167 11.4944 18.006 11.0837 17.5 11.0837H6.5C5.994 11.0837 5.58333 11.4944 5.58333 12.0003V20.7084C5.58333 21.9743 4.55758 23 3.29167 23C2.02575 23 1 21.9743 1 20.7084V9.91316C1 8.38971 1.75717 6.96617 3.01942 6.11461L9.43608 1.78441C10.9853 0.738529 13.0148 0.738529 14.5639 1.78441L20.9806 6.11461C22.2428 6.96708 23 8.39062 23 9.91316ZM10.1667 19.3334H9.25C8.74308 19.3334 8.33333 19.7441 8.33333 20.2501V22.0834C8.33333 22.5893 8.74308 23 9.25 23H10.1667C10.6736 23 11.0833 22.5893 11.0833 22.0834V20.2501C11.0833 19.7441 10.6736 19.3334 10.1667 19.3334ZM10.1667 13.8336H9.25C8.74308 13.8336 8.33333 14.2443 8.33333 14.7503V16.5835C8.33333 17.0895 8.74308 17.5002 9.25 17.5002H10.1667C10.6736 17.5002 11.0833 17.0895 11.0833 16.5835V14.7503C11.0833 14.2443 10.6736 13.8336 10.1667 13.8336ZM14.75 19.3334H13.8333C13.3264 19.3334 12.9167 19.7441 12.9167 20.2501V22.0834C12.9167 22.5893 13.3264 23 13.8333 23H14.75C15.2569 23 15.6667 22.5893 15.6667 22.0834V20.2501C15.6667 19.7441 15.2569 19.3334 14.75 19.3334Z" :fill="$route.path.includes('/stock') ? '#5A9AE8' : '#38485C'"/>
        </svg>
        <span class="menu-title">Warehouse</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex" data-toggle="collapse" data-target="#collapseStock" v-else-if="!route.includes('stock') && (viewStock === true || viewStockSummary === true)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" :fill="$route.path.includes('/stock') ? '#5A9AE8' : '#38485C'">
          <path d="M23 9.91316V20.7084C23 21.9743 21.9743 23 20.7083 23C19.4424 23 18.4167 21.9743 18.4167 20.7084V12.0003C18.4167 11.4944 18.006 11.0837 17.5 11.0837H6.5C5.994 11.0837 5.58333 11.4944 5.58333 12.0003V20.7084C5.58333 21.9743 4.55758 23 3.29167 23C2.02575 23 1 21.9743 1 20.7084V9.91316C1 8.38971 1.75717 6.96617 3.01942 6.11461L9.43608 1.78441C10.9853 0.738529 13.0148 0.738529 14.5639 1.78441L20.9806 6.11461C22.2428 6.96708 23 8.39062 23 9.91316ZM10.1667 19.3334H9.25C8.74308 19.3334 8.33333 19.7441 8.33333 20.2501V22.0834C8.33333 22.5893 8.74308 23 9.25 23H10.1667C10.6736 23 11.0833 22.5893 11.0833 22.0834V20.2501C11.0833 19.7441 10.6736 19.3334 10.1667 19.3334ZM10.1667 13.8336H9.25C8.74308 13.8336 8.33333 14.2443 8.33333 14.7503V16.5835C8.33333 17.0895 8.74308 17.5002 9.25 17.5002H10.1667C10.6736 17.5002 11.0833 17.0895 11.0833 16.5835V14.7503C11.0833 14.2443 10.6736 13.8336 10.1667 13.8336ZM14.75 19.3334H13.8333C13.3264 19.3334 12.9167 19.7441 12.9167 20.2501V22.0834C12.9167 22.5893 13.3264 23 13.8333 23H14.75C15.2569 23 15.6667 22.5893 15.6667 22.0834V20.2501C15.6667 19.7441 15.2569 19.3334 14.75 19.3334Z" :fill="$route.path.includes('/stock') ? '#5A9AE8' : '#38485C'"/>
        </svg>
        <span class="menu-title">Warehouse</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <div id="collapseStock" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="(route === 'stock') && (viewStock === true || viewStockSummary === true)">
        <ul>
          <li class="sidebar link" @click="toStockPage()" v-if="viewStock === true"><a>Stock</a></li>
          <li class="sidebar link" @click="toStockSummaryPage()" v-if="viewStockSummary === true"><a>Stock Summary</a></li>
        </ul>
      </div>
      <div id="collapseStock" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else-if="route != 'stock' && (viewStock === true || viewStockSummary === true)">
        <ul>
          <li class="sidebar link" @click="toStockPage()" v-if="viewStock === true"><a>Stock</a></li>
          <li class="sidebar link" @click="toStockSummaryPage()" v-if="viewStockSummary === true"><a>Stock Summary</a></li>
        </ul>
      </div>
    <!-- End Stock -->

    <!-- Assembly -->
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex active" data-toggle="collapse" data-target="#collapseAssembly" v-if="(route === 'assembly') && viewAssembly === true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'">
          <path d="M10.2069 2.04517C10.0703 2.10946 10.0422 2.24206 9.97391 3.14212C9.93775 3.60421 9.9016 4.02612 9.89356 4.07032C9.8775 4.14264 9.78109 4.19086 9.36331 4.3315C9.0781 4.42793 8.59605 4.63286 8.28271 4.78957L7.72032 5.07084L7.1981 4.63688C6.31836 3.89352 6.30631 3.88548 6.14161 3.88548C6.00101 3.88548 5.93674 3.94576 4.84008 5.04271C3.80769 6.07939 3.68717 6.21199 3.68717 6.32852C3.68717 6.4571 3.88803 6.71828 4.74367 7.71076L4.9405 7.9398L4.71956 8.39385C4.49059 8.86799 4.30982 9.3341 4.16521 9.82029C4.12102 9.98102 4.07281 10.1136 4.06478 10.1136C4.05675 10.1136 3.63093 10.1498 3.11675 10.194C2.21291 10.2743 2.17675 10.2784 2.09239 10.3788L2 10.4793V12.0825C2 13.2156 2.01205 13.7179 2.0482 13.7902C2.11248 13.9309 2.22897 13.955 3.2453 14.0554C3.71931 14.0996 4.11298 14.1438 4.11298 14.1438C4.117 14.1478 4.15717 14.2724 4.20538 14.4251L4.29777 14.6943H4.66332H5.0329V11.3673V8.03623L5.15341 7.84336C5.24178 7.69871 5.33418 7.61433 5.49084 7.53396L5.70375 7.42146H9.28698H12.8662L13.0751 7.51789C13.3041 7.62638 13.5049 7.86345 13.5491 8.07642C13.5652 8.14874 13.5853 8.23714 13.5933 8.2733C13.6053 8.30947 13.7299 8.4059 13.8745 8.48627C15.5858 9.4225 16.4494 11.4396 15.9353 13.292C15.8429 13.6215 15.5978 14.1679 15.4171 14.4572C15.3488 14.5577 15.2965 14.6501 15.2965 14.6662C15.2965 14.6782 15.8067 14.6943 16.4334 14.7023C17.514 14.7144 17.5742 14.7184 17.7349 14.8028C17.9358 14.9113 18.1366 15.1484 18.1888 15.3372C18.2129 15.4216 18.229 16.3618 18.229 17.6356C18.229 18.825 18.2411 19.7974 18.2611 19.7974C18.2772 19.7974 18.7352 19.3513 19.2815 18.8009C19.9282 18.158 20.2817 17.7682 20.3018 17.6959C20.334 17.5552 20.3058 17.511 19.6149 16.6994L19.0445 16.0324L19.2734 15.5662C19.4864 15.1363 19.876 14.0675 19.876 13.9148C19.876 13.8746 19.9081 13.8505 19.9684 13.8505C20.0166 13.8505 20.4545 13.8143 20.9405 13.7701C21.9127 13.6858 21.9328 13.6777 21.985 13.3964C21.997 13.3241 22.0051 12.5848 21.997 11.753C21.985 10.2462 21.985 10.2342 21.8966 10.1458C21.8122 10.0654 21.7279 10.0493 20.82 9.977L19.8318 9.89664L19.7675 9.67162C19.6591 9.29391 19.398 8.66708 19.1529 8.20098L18.9199 7.75496L19.2493 7.35717C20.101 6.3245 20.117 6.30441 20.117 6.1477C20.117 6.00707 20.0568 5.93876 18.9842 4.86189C18.3576 4.23506 17.8072 3.7127 17.759 3.70065C17.7068 3.68458 17.6264 3.68859 17.5782 3.70065C17.526 3.7127 17.1605 4.00201 16.7628 4.33953L16.0437 4.95833L15.7183 4.78555C15.3327 4.58062 14.7141 4.3315 14.2722 4.20693C14.0954 4.1547 13.9347 4.09844 13.9147 4.08237C13.8946 4.0663 13.8464 3.65645 13.8062 3.17427C13.762 2.69209 13.7218 2.25813 13.7098 2.20991C13.6616 2.00499 13.5772 1.99695 11.874 2.00097C10.8577 2.00097 10.2631 2.01704 10.2069 2.04517Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
          <path d="M5.78797 8.02469C5.73976 8.04478 5.68352 8.09702 5.65942 8.14122C5.62729 8.19346 5.61523 9.21407 5.61523 11.3598V14.4979L5.71566 14.5944L5.81207 14.6948H9.33104H12.85L12.9464 14.5944L13.0468 14.4979V11.3839C13.0468 9.18594 13.0348 8.24167 13.0026 8.17336C12.9223 7.99657 12.8299 7.98451 11.5806 7.98451H10.3956V8.90467C10.3956 9.77259 10.3915 9.82884 10.3112 9.9293L10.2309 10.0338H9.33104H8.43121L8.35087 9.9293C8.27053 9.82884 8.26651 9.77259 8.26651 8.90467V7.98451L7.07344 7.98853C6.41463 7.98853 5.83617 8.0046 5.78797 8.02469Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
          <path d="M8.86914 8.72735V9.4707H9.3311H9.79307V8.72735V7.98399H9.3311H8.86914V8.72735Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
          <path d="M2.31711 15.3736L2.2207 15.4499V18.6283V21.8026L2.3131 21.8951L2.40549 21.9875L12.0344 21.9995C18.8554 22.0036 21.6955 21.9955 21.7678 21.9634C21.9847 21.875 22.0209 21.6178 21.8482 21.441L21.7317 21.3245H19.699H17.6664L17.6583 18.3872L17.6463 15.4499L17.5499 15.3736C17.4615 15.3013 17.3772 15.2973 16.2363 15.2973H15.0151V16.1571C15.0151 17.0411 14.987 17.234 14.8544 17.3063C14.8102 17.3304 14.4085 17.3465 13.9305 17.3465C13.0829 17.3465 13.0829 17.3465 12.9865 17.2461L12.8861 17.1496V16.2214V15.2973H11.6488H10.4075L10.3232 15.3897L10.2348 15.4821V18.4033V21.3245H9.9335H9.63222V18.3912C9.63222 15.5102 9.63222 15.458 9.55188 15.3776C9.47555 15.3013 9.41931 15.2973 8.22624 15.2973H6.98094V16.2375V17.1818L6.8765 17.2621C6.77607 17.3425 6.71983 17.3465 5.94855 17.3465C5.14916 17.3465 5.00052 17.3264 4.9242 17.2099C4.90813 17.1858 4.89206 16.7438 4.89206 16.2295V15.2973H3.65078C2.48985 15.2973 2.40549 15.3013 2.31711 15.3736Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
          <path d="M5.45508 16.0204V16.7437H5.93713H6.41918V16.0204V15.2971H5.93713H5.45508V16.0204Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
          <path d="M13.4883 16.0204V16.7437H13.9502H14.4122V16.0204V15.2971H13.9502H13.4883V16.0204Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
        </svg>
        <span class="menu-title">Assembly</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex" data-toggle="collapse" data-target="#collapseAssembly" v-else-if="route != 'assembly' && viewAssembly === true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'">
          <path d="M10.2069 2.04517C10.0703 2.10946 10.0422 2.24206 9.97391 3.14212C9.93775 3.60421 9.9016 4.02612 9.89356 4.07032C9.8775 4.14264 9.78109 4.19086 9.36331 4.3315C9.0781 4.42793 8.59605 4.63286 8.28271 4.78957L7.72032 5.07084L7.1981 4.63688C6.31836 3.89352 6.30631 3.88548 6.14161 3.88548C6.00101 3.88548 5.93674 3.94576 4.84008 5.04271C3.80769 6.07939 3.68717 6.21199 3.68717 6.32852C3.68717 6.4571 3.88803 6.71828 4.74367 7.71076L4.9405 7.9398L4.71956 8.39385C4.49059 8.86799 4.30982 9.3341 4.16521 9.82029C4.12102 9.98102 4.07281 10.1136 4.06478 10.1136C4.05675 10.1136 3.63093 10.1498 3.11675 10.194C2.21291 10.2743 2.17675 10.2784 2.09239 10.3788L2 10.4793V12.0825C2 13.2156 2.01205 13.7179 2.0482 13.7902C2.11248 13.9309 2.22897 13.955 3.2453 14.0554C3.71931 14.0996 4.11298 14.1438 4.11298 14.1438C4.117 14.1478 4.15717 14.2724 4.20538 14.4251L4.29777 14.6943H4.66332H5.0329V11.3673V8.03623L5.15341 7.84336C5.24178 7.69871 5.33418 7.61433 5.49084 7.53396L5.70375 7.42146H9.28698H12.8662L13.0751 7.51789C13.3041 7.62638 13.5049 7.86345 13.5491 8.07642C13.5652 8.14874 13.5853 8.23714 13.5933 8.2733C13.6053 8.30947 13.7299 8.4059 13.8745 8.48627C15.5858 9.4225 16.4494 11.4396 15.9353 13.292C15.8429 13.6215 15.5978 14.1679 15.4171 14.4572C15.3488 14.5577 15.2965 14.6501 15.2965 14.6662C15.2965 14.6782 15.8067 14.6943 16.4334 14.7023C17.514 14.7144 17.5742 14.7184 17.7349 14.8028C17.9358 14.9113 18.1366 15.1484 18.1888 15.3372C18.2129 15.4216 18.229 16.3618 18.229 17.6356C18.229 18.825 18.2411 19.7974 18.2611 19.7974C18.2772 19.7974 18.7352 19.3513 19.2815 18.8009C19.9282 18.158 20.2817 17.7682 20.3018 17.6959C20.334 17.5552 20.3058 17.511 19.6149 16.6994L19.0445 16.0324L19.2734 15.5662C19.4864 15.1363 19.876 14.0675 19.876 13.9148C19.876 13.8746 19.9081 13.8505 19.9684 13.8505C20.0166 13.8505 20.4545 13.8143 20.9405 13.7701C21.9127 13.6858 21.9328 13.6777 21.985 13.3964C21.997 13.3241 22.0051 12.5848 21.997 11.753C21.985 10.2462 21.985 10.2342 21.8966 10.1458C21.8122 10.0654 21.7279 10.0493 20.82 9.977L19.8318 9.89664L19.7675 9.67162C19.6591 9.29391 19.398 8.66708 19.1529 8.20098L18.9199 7.75496L19.2493 7.35717C20.101 6.3245 20.117 6.30441 20.117 6.1477C20.117 6.00707 20.0568 5.93876 18.9842 4.86189C18.3576 4.23506 17.8072 3.7127 17.759 3.70065C17.7068 3.68458 17.6264 3.68859 17.5782 3.70065C17.526 3.7127 17.1605 4.00201 16.7628 4.33953L16.0437 4.95833L15.7183 4.78555C15.3327 4.58062 14.7141 4.3315 14.2722 4.20693C14.0954 4.1547 13.9347 4.09844 13.9147 4.08237C13.8946 4.0663 13.8464 3.65645 13.8062 3.17427C13.762 2.69209 13.7218 2.25813 13.7098 2.20991C13.6616 2.00499 13.5772 1.99695 11.874 2.00097C10.8577 2.00097 10.2631 2.01704 10.2069 2.04517Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
          <path d="M5.78797 8.02469C5.73976 8.04478 5.68352 8.09702 5.65942 8.14122C5.62729 8.19346 5.61523 9.21407 5.61523 11.3598V14.4979L5.71566 14.5944L5.81207 14.6948H9.33104H12.85L12.9464 14.5944L13.0468 14.4979V11.3839C13.0468 9.18594 13.0348 8.24167 13.0026 8.17336C12.9223 7.99657 12.8299 7.98451 11.5806 7.98451H10.3956V8.90467C10.3956 9.77259 10.3915 9.82884 10.3112 9.9293L10.2309 10.0338H9.33104H8.43121L8.35087 9.9293C8.27053 9.82884 8.26651 9.77259 8.26651 8.90467V7.98451L7.07344 7.98853C6.41463 7.98853 5.83617 8.0046 5.78797 8.02469Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
          <path d="M8.86914 8.72735V9.4707H9.3311H9.79307V8.72735V7.98399H9.3311H8.86914V8.72735Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
          <path d="M2.31711 15.3736L2.2207 15.4499V18.6283V21.8026L2.3131 21.8951L2.40549 21.9875L12.0344 21.9995C18.8554 22.0036 21.6955 21.9955 21.7678 21.9634C21.9847 21.875 22.0209 21.6178 21.8482 21.441L21.7317 21.3245H19.699H17.6664L17.6583 18.3872L17.6463 15.4499L17.5499 15.3736C17.4615 15.3013 17.3772 15.2973 16.2363 15.2973H15.0151V16.1571C15.0151 17.0411 14.987 17.234 14.8544 17.3063C14.8102 17.3304 14.4085 17.3465 13.9305 17.3465C13.0829 17.3465 13.0829 17.3465 12.9865 17.2461L12.8861 17.1496V16.2214V15.2973H11.6488H10.4075L10.3232 15.3897L10.2348 15.4821V18.4033V21.3245H9.9335H9.63222V18.3912C9.63222 15.5102 9.63222 15.458 9.55188 15.3776C9.47555 15.3013 9.41931 15.2973 8.22624 15.2973H6.98094V16.2375V17.1818L6.8765 17.2621C6.77607 17.3425 6.71983 17.3465 5.94855 17.3465C5.14916 17.3465 5.00052 17.3264 4.9242 17.2099C4.90813 17.1858 4.89206 16.7438 4.89206 16.2295V15.2973H3.65078C2.48985 15.2973 2.40549 15.3013 2.31711 15.3736Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
          <path d="M5.45508 16.0204V16.7437H5.93713H6.41918V16.0204V15.2971H5.93713H5.45508V16.0204Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
          <path d="M13.4883 16.0204V16.7437H13.9502H14.4122V16.0204V15.2971H13.9502H13.4883V16.0204Z" :fill="$route.path.includes('/assembly') ? '#5A9AE8' : '#38485C'"/>
        </svg>
        <span class="menu-title">Assembly</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <div id="collapseAssembly" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="(route === 'assembly') && viewAssembly === true ">
        <ul>
          <li class="sidebar link" @click="toChangeSpecPage" v-if="viewAssembly === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path === '/assembly/change-spec' ? '#5A9AE8' : '#38485C'}`">
                Ubah Spesifikasi
              </span>
            </a>
          </li>
          <li class="sidebar link" @click="toChangeSparepartPage" v-if="viewAssembly === true && viewChangeSparepart === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path === '/assembly/sparepart-change' ? '#5A9AE8' : '#38485C'}`">
                Perubahan Sparepart
              </span>
            </a>
          </li>
          <li class="sidebar link" @click="toFixUnitPage" v-if="viewAssembly === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path === '/assembly/perbaikan' ? '#5A9AE8' : '#38485C'}`">
                Perbaikan Unit Rusak
              </span>
            </a>
          </li>
          <li class="sidebar link" @click="toUpdateInfoPage" v-if="viewAssembly === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path === '/assembly/updateInfo' ? '#5A9AE8' : '#38485C'}`">
                Update Info Unit
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div id="collapseAssembly" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else-if="route != 'assembly' && viewAssembly === true">
        <ul>
          <li class="sidebar link" @click="toChangeSpecPage" v-if="viewAssembly === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path === '/assembly/change-spec' ? '#5A9AE8' : '#38485C'}`">
                Ubah Spesifikasi
              </span>
            </a>
          </li>
          <li class="sidebar link" @click="toChangeSparepartPage" v-if="viewAssembly === true && viewChangeSparepart === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path === '/assembly/sparepart-change' ? '#5A9AE8' : '#38485C'}`">
                Perubahan Sparepart
              </span>
            </a>
          </li>
          <li class="sidebar link" @click="toFixUnitPage" v-if="viewAssembly === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path === '/assembly/perbaikan' ? '#5A9AE8' : '#38485C'}`">
                Perbaikan Unit Rusak
              </span>
            </a>
          </li>
          <li class="sidebar link" @click="toUpdateInfoPage" v-if="viewAssembly === true">
            <a class='list-group-item bg-light link'>
              <span :style="`color : ${$route.path === '/assembly/updateInfo' ? '#5A9AE8' : '#38485C'}`">
                Update Info Unit
              </span>
            </a>
          </li>
        </ul>
      </div>
    <!-- Assembly End -->
      <!-- <a class="list-group-item list-group-item-action bg-light link active" @click="toProcurePage" v-if="route === 'procure' && viewProcure === true">
        <i class="fas fa-comment"></i>
        <span class="menu-title">Procure</span><span class="badge badge-danger badge-resolution"></span>
      </a>
      <a class="list-group-item list-group-item-action bg-light link" @click="toProcurePage" v-else-if="route != 'procure' && viewProcure === true">
        <i class="fas fa-comment"></i>
        <span class="menu-title">Procure</span><span class="badge badge-danger badge-resolution"></span>
      </a> -->

      <!-- QC -->

      <a href="#" class="list-group-item list-group-item-action bg-light d-flex active" data-toggle="collapse" data-target="#collapseQC" v-if="(route === 'quality-control' || route === 'return' || route === 'unmatch') && (viewQc || viewUnmatch)"> 
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M17.5 11C14.4622 11 12 13.4622 12 16.5C12 19.5378 14.4622 22 17.5 22C20.5378 22 23 19.5378 23 16.5C23 13.4622 20.5378 11 17.5 11ZM17.9583 19.7083H17.5C16.9931 19.7083 16.5833 19.2986 16.5833 18.7917C16.5833 18.2847 16.9931 17.875 17.5 17.875H17.9583C18.4643 17.875 18.875 17.4643 18.875 16.9583C18.875 16.4523 18.4643 16.0417 17.9583 16.0417H16.5833V17.0188C16.444 17.4102 15.9206 17.5661 15.5942 17.2397L14.0836 15.7291C13.7499 15.3954 13.7499 14.8546 14.0836 14.5209L15.5942 13.0103C15.9206 12.6839 16.444 12.8398 16.5833 13.2312V14.2074H17.9583C19.4745 14.2074 20.7083 15.4413 20.7083 16.9574C20.7083 18.4736 19.4745 19.7083 17.9583 19.7083ZM2.15042 4.06542C2.36308 3.86375 2.59867 3.68317 2.859 3.53467L8.183 0.520667C8.78433 0.180583 9.46633 0 10.1548 0H10.1584C10.8487 0 11.5307 0.17875 12.1311 0.517917L17.4697 3.53467C17.7328 3.68317 17.9693 3.86467 18.1829 4.06725L10.1685 8.64783L2.15042 4.06542ZM9.24175 19.8137C8.93925 19.734 8.64408 19.6148 8.36725 19.4563L2.848 16.3011C1.70858 15.6503 1 14.4302 1 13.1175V6.72558C1 6.34517 1.066 5.97483 1.17783 5.621L9.24908 10.2337C9.24908 11.2869 9.2445 16.5458 9.24175 19.8137ZM11.0806 12.9571C11.0815 11.6683 11.0824 10.6443 11.0824 10.2382L19.1555 5.62467C19.2673 5.97758 19.3333 6.34792 19.3333 6.72742V9.40683C18.7467 9.25558 18.1343 9.16667 17.5 9.16667C14.7353 9.16667 12.33 10.6975 11.0806 12.9571Z" fill="#247FEC"/>
        </svg>
        <span class="menu-title">Return</span>
        <div class="right-arrow">
          <span class="badge badge-danger badge-order" v-if="qc+unmatch != '0' && viewQc && viewUnmatch">{{ qc+unmatch }}</span>
          <span class="badge badge-danger badge-order" v-else-if="qc+unmatch != '0' && viewQc && viewUnmatch == false">{{ qc }}</span>
          <span class="badge badge-danger badge-order" v-else-if="qc+unmatch != '0' && viewQc == false && viewUnmatch">{{unmatch }}</span>
          <i class="fas fa-angle-down"></i>
        </div>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex" data-toggle="collapse" data-target="#collapseQC" v-else-if="(route != 'quality-control' || route != 'return' || route != 'unmatch') && (viewQc || viewUnmatch)"> 
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M17.5 11C14.4622 11 12 13.4622 12 16.5C12 19.5378 14.4622 22 17.5 22C20.5378 22 23 19.5378 23 16.5C23 13.4622 20.5378 11 17.5 11ZM17.9583 19.7083H17.5C16.9931 19.7083 16.5833 19.2986 16.5833 18.7917C16.5833 18.2847 16.9931 17.875 17.5 17.875H17.9583C18.4643 17.875 18.875 17.4643 18.875 16.9583C18.875 16.4523 18.4643 16.0417 17.9583 16.0417H16.5833V17.0188C16.444 17.4102 15.9206 17.5661 15.5942 17.2397L14.0836 15.7291C13.7499 15.3954 13.7499 14.8546 14.0836 14.5209L15.5942 13.0103C15.9206 12.6839 16.444 12.8398 16.5833 13.2312V14.2074H17.9583C19.4745 14.2074 20.7083 15.4413 20.7083 16.9574C20.7083 18.4736 19.4745 19.7083 17.9583 19.7083ZM2.15042 4.06542C2.36308 3.86375 2.59867 3.68317 2.859 3.53467L8.183 0.520667C8.78433 0.180583 9.46633 0 10.1548 0H10.1584C10.8487 0 11.5307 0.17875 12.1311 0.517917L17.4697 3.53467C17.7328 3.68317 17.9693 3.86467 18.1829 4.06725L10.1685 8.64783L2.15042 4.06542ZM9.24175 19.8137C8.93925 19.734 8.64408 19.6148 8.36725 19.4563L2.848 16.3011C1.70858 15.6503 1 14.4302 1 13.1175V6.72558C1 6.34517 1.066 5.97483 1.17783 5.621L9.24908 10.2337C9.24908 11.2869 9.2445 16.5458 9.24175 19.8137ZM11.0806 12.9571C11.0815 11.6683 11.0824 10.6443 11.0824 10.2382L19.1555 5.62467C19.2673 5.97758 19.3333 6.34792 19.3333 6.72742V9.40683C18.7467 9.25558 18.1343 9.16667 17.5 9.16667C14.7353 9.16667 12.33 10.6975 11.0806 12.9571Z" fill="#2E3646"/>
        </svg>
        <span class="menu-title">Return</span>
        <div class="right-arrow">
          <span class="badge badge-danger badge-order" v-if="qc+unmatch != '0' && viewQc && viewUnmatch">{{ qc+unmatch }}</span>
          <span class="badge badge-danger badge-order" v-else-if="qc+unmatch != '0' && viewQc && viewUnmatch == false">{{ qc }}</span>
          <span class="badge badge-danger badge-order" v-else-if="qc+unmatch != '0' && viewQc == false && viewUnmatch">{{unmatch }}</span>
          <i class="fas fa-angle-down"></i></div>
      </a>
      <div id="collapseQC" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="(route === 'quality-control' || route === 'unmatch' || route === 'return')  && (viewQc || viewUnmatch)">
        <ul>
          <li class="sidebar link" @click="toReturnPage('qc')" v-if="viewQc === true"><a>Quality Control <span class="badge badge-danger badge-order" v-if="qc != '0'">{{ qc }}</span></a></li>
          <li class="sidebar link" @click="toReturnPage('up')" v-if="viewUnmatch === true"><a>Unmatch Product <span class="badge badge-danger badge-order" v-if="unmatch != '0'">{{ unmatch }}</span></a></li>
        </ul>
      </div>
      <div id="collapseQC" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else-if="(route !== 'quality-control' || route !== 'unmatch' || route === 'return')  && (viewQc || viewUnmatch)">
        <ul>
          <li class="sidebar link" @click="toReturnPage('qc')" v-if="viewQc === true"><a>Quality Control <span class="badge badge-danger badge-order" v-if="qc != '0'">{{ qc }}</span></a></li>
          <li class="sidebar link" @click="toReturnPage('up')" v-if="viewUnmatch === true"><a>Unmatch Product <span class="badge badge-danger badge-order" v-if="unmatch != '0'">{{ unmatch }}</span></a></li>
        </ul>
      </div>
      <!-- QC end -->

      <!--  <a href="#" class="list-group-item list-group-item-action bg-light d-flex active" data-toggle="collapse" data-target="#collapseWarehouse" v-if="showWarehouseInventoryMenu()">
                    <i class="fas fa-box-open"></i>
                    <span class="menu-title">Warehouse</span>
                    <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
                </a>
                <a href="#" class="list-group-item list-group-item-action bg-light d-flex" data-toggle="collapse" data-target="#collapseWarehouse" v-else-if="showWarehouseInventoryMenu()">
                    <i class="fas fa-box-open"></i>
                    <span class="menu-title">Warehouse</span>
                    <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
                </a>
                <div id="collapseWarehouse" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="showWarehouseInventoryMenu()">
                    <ul>
                        <li class="sidebar link" @click="toInventorySparepartPage"><a>Inventory Sparepart</a></li>
                        <li class="sidebar link" @click="toInventoryProductPage"><a>Inventory Product</a></li>
                        <li class="sidebar link" @click="toPage('/assembly')"><a>Assembly</a></li>
                        <li class="sidebar link" @click="toOrderListPage"><a>Order List</a></li>
                        <li class="sidebar link" @click="toProductCatalogPage"><a>Settings</a></li>
                    </ul>
                </div>
                <div id="collapseWarehouse" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else-if="showWarehouseInventoryMenu()">
                    <ul>
                        <li class="sidebar link" @click="toInventorySparepartPage"><a>Inventory Sparepart</a></li>
                        <li class="sidebar link" @click="toInventoryProductPage"><a>Inventory Product</a></li>
                        <li class="sidebar link" @click="toPage('/assembly')"><a>Assembly</a></li>
                        <li class="sidebar link" @click="toOrderListPage"><a>Order List</a></li>
                        <li class="sidebar link" @click="toProductCatalogPage"><a>Settings</a></li>
                    </ul>
                </div> -->
      <!-- Service Part -->
      <a class="list-group-item list-group-item-action bg-light d-flex link active" @click="toServicePage" v-if="route === 'service' && viewService === true">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M10.6546 15.1887C11.2005 15.7337 11.2005 16.6185 10.6546 17.1644L5.60939 22.2093C4.52122 23.2974 2.73508 23.2626 1.69087 22.104C0.712618 21.0177 0.865585 19.3168 1.8988 18.2836L6.83588 13.3468C7.38088 12.8018 8.26571 12.8009 8.81071 13.3468L10.6536 15.1896L10.6546 15.1887ZM15.6118 11.0789C16.7687 11.0807 17.942 11.5378 18.8058 12.4024C19.3196 12.908 20.0084 12.8109 20.2356 12.6543C21.9018 11.5012 23 9.59235 23 7.41243C23 7.03415 22.9661 6.66412 22.9029 6.30416C22.7783 5.60072 21.8889 5.35067 21.3833 5.85535L19.8747 7.36389C18.825 8.41355 17.4446 8.57475 16.5177 7.81636C15.4515 6.94439 15.3929 5.36899 16.3427 4.41917L18.1426 2.61937C18.6473 2.11377 18.4 1.22166 17.6965 1.09709C17.3366 1.03297 16.9665 1 16.5882 1C13.8925 1 11.5916 2.66516 10.6445 5.02185C10.4549 5.49264 10.5657 6.03396 10.9248 6.39209L15.6118 11.078V11.0789ZM17.5106 13.6976C16.8135 13.0005 15.8335 12.7752 14.9422 13.0005L8.32708 6.38659V4.66372C8.32708 3.97494 7.95886 3.33746 7.36164 2.99307L4.24185 1.19418C3.67578 0.86719 2.96041 0.961531 2.49784 1.42408L1.42433 2.49755C0.960846 2.96009 0.866501 3.67635 1.1935 4.2424L2.99338 7.36297C3.33779 7.96016 3.97439 8.32745 4.6632 8.32745H6.38339L13.0004 14.9432C12.7759 15.8335 13.0004 16.8136 13.6974 17.5106L18.3295 22.093C19.3801 23.1436 21.1946 23.2434 22.2443 22.1919C23.2959 21.1386 23.163 19.5659 22.2434 18.3798L17.5106 13.6976Z" fill="#247FEC"/>
        </svg>
        <span class="menu-title">Service</span>
      </a>
      <a class="list-group-item list-group-item-action bg-light d-flex link" @click="toServicePage" v-else-if="route != 'service' && viewService === true">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M10.6546 15.1887C11.2005 15.7337 11.2005 16.6185 10.6546 17.1644L5.60939 22.2093C4.52122 23.2974 2.73508 23.2626 1.69087 22.104C0.712618 21.0177 0.865585 19.3168 1.8988 18.2836L6.83588 13.3468C7.38088 12.8018 8.26571 12.8009 8.81071 13.3468L10.6536 15.1896L10.6546 15.1887ZM15.6118 11.0789C16.7687 11.0807 17.942 11.5378 18.8058 12.4024C19.3196 12.908 20.0084 12.8109 20.2356 12.6543C21.9018 11.5012 23 9.59235 23 7.41243C23 7.03415 22.9661 6.66412 22.9029 6.30416C22.7783 5.60072 21.8889 5.35067 21.3833 5.85535L19.8747 7.36389C18.825 8.41355 17.4446 8.57475 16.5177 7.81636C15.4515 6.94439 15.3929 5.36899 16.3427 4.41917L18.1426 2.61937C18.6473 2.11377 18.4 1.22166 17.6965 1.09709C17.3366 1.03297 16.9665 1 16.5882 1C13.8925 1 11.5916 2.66516 10.6445 5.02185C10.4549 5.49264 10.5657 6.03396 10.9248 6.39209L15.6118 11.078V11.0789ZM17.5106 13.6976C16.8135 13.0005 15.8335 12.7752 14.9422 13.0005L8.32708 6.38659V4.66372C8.32708 3.97494 7.95886 3.33746 7.36164 2.99307L4.24185 1.19418C3.67578 0.86719 2.96041 0.961531 2.49784 1.42408L1.42433 2.49755C0.960846 2.96009 0.866501 3.67635 1.1935 4.2424L2.99338 7.36297C3.33779 7.96016 3.97439 8.32745 4.6632 8.32745H6.38339L13.0004 14.9432C12.7759 15.8335 13.0004 16.8136 13.6974 17.5106L18.3295 22.093C19.3801 23.1436 21.1946 23.2434 22.2443 22.1919C23.2959 21.1386 23.163 19.5659 22.2434 18.3798L17.5106 13.6976Z" fill="#2E3646"/>
        </svg>
        <span class="menu-title">Service</span>
      </a> 
      <!-- End Of Service Part -->
      <!-- DISPOSAL PART -->
      <a class="list-group-item list-group-item-action bg-light link active" @click="toDisposalPage" v-if="route === 'disposal' && viewDisposal === true">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="#247FEC">
          <path d="M12.8364 2.00512C14.1928 2.00513 15.5134 2.00763 16.8341 2.00434C17.884 2.00172 18.7149 2.41817 19.3258 3.29364C19.9986 4.25768 20.679 5.21638 21.3683 6.16833C21.7918 6.75318 22.0009 7.39512 22 8.12162C21.995 12.175 22.0039 16.2284 21.9943 20.2818C21.9908 21.7376 20.7242 22.9963 19.2854 22.9974C14.443 23.0009 9.60053 23.0008 4.7581 22.9974C3.40475 22.9964 2.24051 21.9096 2.06393 20.4899C2.02688 20.192 2.00889 19.8896 2.0086 19.5893C2.00497 15.8496 2.0146 12.1098 2.00004 8.3701C1.99661 7.49026 2.21873 6.72109 2.7503 6.01729C3.40759 5.14703 4.03711 4.2537 4.64629 3.34798C5.27465 2.41375 6.16592 2.02248 7.23257 2.01079C9.08842 1.99044 10.9446 2.00513 12.8364 2.00512ZM13.194 11.0896C13.0416 10.9371 12.8958 10.777 12.7357 10.6333C12.2641 10.2101 11.6861 10.2273 11.236 10.6717C11.0912 10.8148 10.9498 10.9616 10.8068 11.1066C9.89821 12.0278 8.98375 12.9432 8.083 13.8722C7.46503 14.5096 7.7029 15.4929 8.51814 15.7133C8.94782 15.8295 9.31008 15.7001 9.62043 15.384C10.0363 14.9605 10.4587 14.5436 10.9138 14.0882C10.9209 14.2471 10.9303 14.362 10.9304 14.4768C10.9314 15.8158 10.9335 17.1548 10.9297 18.4938C10.9284 18.961 11.0712 19.353 11.4843 19.5935C12.2045 20.0128 13.0541 19.5067 13.0662 18.6317C13.0854 17.2447 13.0724 15.8572 13.073 14.4699C13.073 14.3559 13.073 14.2418 13.073 14.0584C13.5489 14.5352 13.9689 14.9558 14.3886 15.3768C14.87 15.8596 15.5464 15.8901 15.9752 15.4478C16.4108 14.9985 16.3828 14.3254 15.9044 13.839C15.0138 12.9336 14.1214 12.0301 13.194 11.0896ZM15.5851 4.90088C13.1843 4.90088 10.7835 4.89998 8.38277 4.9017C7.9443 4.90202 7.43593 4.77549 7.08704 4.95781C6.73836 5.14002 6.54679 5.63438 6.29089 5.99522C6.04689 6.3393 5.80876 6.68766 5.55937 7.04663C9.88184 7.04663 14.1506 7.04663 18.4588 7.04663C18.1948 6.66817 17.9571 6.32487 17.7166 5.98361C17.4683 5.63132 17.2867 5.1428 16.9482 4.96802C16.5974 4.78685 16.0935 4.91053 15.5851 4.90088Z" fill="#247FEC"/>
        </svg>
        <span class="menu-title">Disposal</span>
      </a>
      <a class="list-group-item list-group-item-action bg-light link" @click="toDisposalPage" v-else-if="route != 'disposal' && viewDisposal === true">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="#2E3646">
          <path d="M12.8364 2.00512C14.1928 2.00513 15.5134 2.00763 16.8341 2.00434C17.884 2.00172 18.7149 2.41817 19.3258 3.29364C19.9986 4.25768 20.679 5.21638 21.3683 6.16833C21.7918 6.75318 22.0009 7.39512 22 8.12162C21.995 12.175 22.0039 16.2284 21.9943 20.2818C21.9908 21.7376 20.7242 22.9963 19.2854 22.9974C14.443 23.0009 9.60053 23.0008 4.7581 22.9974C3.40475 22.9964 2.24051 21.9096 2.06393 20.4899C2.02688 20.192 2.00889 19.8896 2.0086 19.5893C2.00497 15.8496 2.0146 12.1098 2.00004 8.3701C1.99661 7.49026 2.21873 6.72109 2.7503 6.01729C3.40759 5.14703 4.03711 4.2537 4.64629 3.34798C5.27465 2.41375 6.16592 2.02248 7.23257 2.01079C9.08842 1.99044 10.9446 2.00513 12.8364 2.00512ZM13.194 11.0896C13.0416 10.9371 12.8958 10.777 12.7357 10.6333C12.2641 10.2101 11.6861 10.2273 11.236 10.6717C11.0912 10.8148 10.9498 10.9616 10.8068 11.1066C9.89821 12.0278 8.98375 12.9432 8.083 13.8722C7.46503 14.5096 7.7029 15.4929 8.51814 15.7133C8.94782 15.8295 9.31008 15.7001 9.62043 15.384C10.0363 14.9605 10.4587 14.5436 10.9138 14.0882C10.9209 14.2471 10.9303 14.362 10.9304 14.4768C10.9314 15.8158 10.9335 17.1548 10.9297 18.4938C10.9284 18.961 11.0712 19.353 11.4843 19.5935C12.2045 20.0128 13.0541 19.5067 13.0662 18.6317C13.0854 17.2447 13.0724 15.8572 13.073 14.4699C13.073 14.3559 13.073 14.2418 13.073 14.0584C13.5489 14.5352 13.9689 14.9558 14.3886 15.3768C14.87 15.8596 15.5464 15.8901 15.9752 15.4478C16.4108 14.9985 16.3828 14.3254 15.9044 13.839C15.0138 12.9336 14.1214 12.0301 13.194 11.0896ZM15.5851 4.90088C13.1843 4.90088 10.7835 4.89998 8.38277 4.9017C7.9443 4.90202 7.43593 4.77549 7.08704 4.95781C6.73836 5.14002 6.54679 5.63438 6.29089 5.99522C6.04689 6.3393 5.80876 6.68766 5.55937 7.04663C9.88184 7.04663 14.1506 7.04663 18.4588 7.04663C18.1948 6.66817 17.9571 6.32487 17.7166 5.98361C17.4683 5.63132 17.2867 5.1428 16.9482 4.96802C16.5974 4.78685 16.0935 4.91053 15.5851 4.90088Z" fill="#2E3646"/>
        </svg>
        <span class="menu-title">Disposal</span>
      </a>
      <!-- END OF DISPOSAL -->
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex" data-toggle="collapse" data-target="#collapsePayment" v-if="route === 'payment' && (viewPairing === true || viewReconcile === true)">
        <i class="fas fa-file-invoice-dollar"></i>
        <span class="menu-title-payment">Payment</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex" data-toggle="collapse" data-target="#collapsePayment" v-else-if="route != 'payment' && (viewPairing === true || viewReconcile === true)">
        <i class="fas fa-file-invoice-dollar"></i>
        <span class="menu-title-payment">Payment</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <div id="collapsePayment" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="route === 'payment'">
        <ul>
          <li class="sidebar link" v-if="viewPairing === true"><a @click="toPage('/payment/pairing')">Pairing</a></li>
          <li class="sidebar link" v-if="viewReconcile === true"><a @click="toPage('/payment/reconcile')">Reconcile</a></li>
        </ul>
      </div>
      <div id="collapsePayment" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else>
        <ul>
          <li class="sidebar link" v-if="viewPairing === true"><a @click="toPage('/payment/pairing')">Pairing</a></li>
          <li class="sidebar link" v-if="viewReconcile === true"><a @click="toPage('/payment/reconcile')">Reconcile</a></li>
        </ul>
      </div>

      <a class="list-group-item list-group-item-action bg-light link active" @click="toResolutionPage" v-if="route === 'resolution' && viewResolution === true">
        <i class="fas fa-comment"></i>
        <span class="menu-title">Resolution Center</span><span class="badge badge-danger badge-resolution" v-if="pendingComplain != '0'">{{ pendingComplain }}</span>
      </a>
      <a class="list-group-item list-group-item-action bg-light link" @click="toResolutionPage" v-else-if="route != 'resolution' && viewResolution === true">
        <i class="fas fa-comment"></i>
        <span class="menu-title">Resolution Center</span><span class="badge badge-danger badge-resolution" v-if="pendingComplain != '0'">{{ pendingComplain }}</span>
      </a>

      <!-- INVOICING -->
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex link active" data-toggle="collapse" data-target="#collapseInvoice" v-if="route === 'invoicing'  && viewInvoicing == true &&  (viewPendingInvoice === true || viewInvoiceList === true || viewPaymentList === true || viewConfirmPayment == true)">
        <i class="fas fa-light fa-money-bill"></i>
        <span class="menu-title">Invoicing</span>
        <div class="right-arrow"><span class="badge badge-danger badge-order" v-if="pendingInvoiceCount != '0' || openInvoiceCount != '0'">{{ pendingInvoiceCount + openInvoiceCount }}</span><i class="fas fa-angle-down"></i></div>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex link" data-toggle="collapse" data-target="#collapseInvoice" v-else-if="route != 'invoicing'  && viewInvoicing == true &&  (viewPendingInvoice === true || viewInvoiceList === true || viewPaymentList === true || viewConfirmPayment == true)">
        <i class="fas fa-light fa-money-bill"></i>
        <span class="menu-title">Invoicing</span>
        <div class="right-arrow"><span class="badge badge-danger badge-order" v-if="pendingInvoiceCount != '0' || openInvoiceCount != '0'">{{ pendingInvoiceCount + openInvoiceCount }}</span><i class="fas fa-angle-down"></i></div>
      </a>
      <div id="collapseInvoice" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="route === 'invoicing' && viewInvoicing === true && (viewPendingInvoice === true || viewInvoiceList === true || viewPaymentList === true || viewConfirmPayment == true)">
        <ul>
          <li class="sidebar link" v-if="viewPendingInvoice === true">
            <a @click="toInvoicePendingPage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 21" fill="none">
                <path 
                  d="M12 14.69V11H13.5V13.82L15.94 15.23L15.19 16.53L12 14.69ZM16.5 1.5L15 0L13.5 1.5L12 0L10.5 1.5L9 0L7.5 1.5L6 0L4.5 1.5L3 0L1.5 1.5L0 0L0 20L1.5 18.5L3 20L4.5 18.5L6 20L7.58 18.42C7.72 18.61 7.88 18.78 8.05 18.95C9.36192 20.2423 11.1302 20.9657 12.9717 20.9634C14.8133 20.9611 16.5797 20.2334 17.8885 18.9378C19.1972 17.6423 19.9427 15.8832 19.9636 14.0418C19.9845 12.2004 19.279 10.4249 18 9.1V0L16.5 1.5ZM8.1 9C7.5 9.57 7.03 10.25 6.67 11H3V9H8.1ZM6.07 13C6 13.33 6 13.66 6 14C6 14.34 6 14.67 6.07 15H3V13H6.07ZM15 7L3 7V5L15 5V7ZM17.85 14C17.85 14.64 17.73 15.27 17.5 15.86C17.24 16.44 16.88 17 16.43 17.43C16 17.88 15.44 18.24 14.86 18.5C14.27 18.73 13.64 18.85 13 18.85C10.32 18.85 8.15 16.68 8.15 14C8.15 12.71 8.66 11.5 9.57 10.57C10.5 9.66 11.71 9.15 13 9.15C15.67 9.15 17.85 11.32 17.85 14Z" 
                  :fill="$route.path === '/invoicing/pending' ? '#5A9AE8' : '#38485C'"
                />
              </svg>
              <span :style="`color : ${$route.path === '/invoicing/pending' ? '#5A9AE8' : '#38485C'}`">Pending Invoice</span>
              <span class="badge badge-danger badge-order pb-1" v-if="pendingInvoiceCount != '0'">
                {{ pendingInvoiceCount }}
              </span>
            </a>
          </li>
          <li class="sidebar link" v-if="viewInvoiceList === true">
            <a @click="toInvoiceListPage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                <path 
                  d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
                  :fill="$route.path === '/invoicing/list' ? '#5A9AE8' : '#38485C'"
                />
              </svg>
              <span :style="`color : ${$route.path === '/invoicing/list' ? '#5A9AE8' : '#38485C'}`">Invoice List</span>
              <span class="badge badge-danger badge-order" v-if="openInvoiceCount != '0'">
                {{ openInvoiceCount }}
              </span>
            </a>
          </li>
          <!-- Invoice sub menu  -->
          <!-- <li class="sidebar link" v-if="viewPaymentList === true">
            <a @click="toInvoicePaymentListPage()" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path 
                  d="M10 8.23C9.2 7.493 7.793 6.98 6.5 6.948M6.5 6.948C4.961 6.91 3.583 7.551 3.583 9.307C3.583 12.537 10 10.922 10 14.153C10 15.995 8.292 16.787 6.5 16.728M6.5 6.948V5M3 15.23C3.752 16.155 5.15 16.683 6.5 16.728M6.5 16.728L6.5 19M21 12H13M13 12L16.84 8M13 12L16.84 16" 
                  :stroke="$route.path === '/invoicing/payments' ? '#5A9AE8' : '#38485C'" 
                  stroke-width="1.5" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"
                  :fill="$route.path === '/invoicing/payment-list' ? '#5A9AE8' : '#38485C'"
                  />
              </svg>
              <span :style="`color : ${$route.path === '/invoicing/payments' ? '#5A9AE8' : '#38485C'}`">Payment List</span>
            </a>
          </li>
          <li class="sidebar link" v-if="viewConfirmPayment === true">
            <a @click="toInvoicePaymentConfirmationPage()" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path 
                  d="M10 13C10.2833 13 10.521 12.904 10.713 12.712C10.905 12.52 11.0007 12.2827 11 12C11 11.7167 10.904 11.479 10.712 11.287C10.52 11.095 10.2827 10.9993 10 11C9.71667 11 9.479 11.096 9.287 11.288C9.095 11.48 8.99934 11.7173 9 12C9 12.2833 9.096 12.521 9.288 12.713C9.48 12.905 9.71734 13.0007 10 13ZM10 9C10.2833 9 10.521 8.904 10.713 8.712C10.905 8.52 11.0007 8.28267 11 8C11 7.71667 10.904 7.479 10.712 7.287C10.52 7.095 10.2827 6.99934 10 7C9.71667 7 9.479 7.096 9.287 7.288C9.095 7.48 8.99934 7.71734 9 8C9 8.28334 9.096 8.521 9.288 8.713C9.48 8.905 9.71734 9.00067 10 9ZM10 5C10.2833 5 10.521 4.904 10.713 4.712C10.905 4.52 11.0007 4.28267 11 4C11 3.71667 10.904 3.479 10.712 3.287C10.52 3.095 10.2827 2.99934 10 3C9.71667 3 9.479 3.096 9.287 3.288C9.095 3.48 8.99934 3.71734 9 4C9 4.28334 9.096 4.521 9.288 4.713C9.48 4.905 9.71734 5.00067 10 5ZM18 16H2C1.45 16 0.979002 15.804 0.587002 15.412C0.195002 15.02 -0.000664969 14.5493 1.69779e-06 14L1.69779e-06 10C0.550002 10 1.021 9.804 1.413 9.412C1.805 9.02 2.00067 8.54934 2 8C2 7.45 1.804 6.979 1.412 6.587C1.02 6.195 0.549335 5.99934 1.69779e-06 6L1.69779e-06 2C1.69779e-06 1.45 0.196002 0.979002 0.588002 0.587002C0.980002 0.195002 1.45067 -0.000664969 2 1.69779e-06L18 1.69779e-06C18.55 1.69779e-06 19.021 0.196001 19.413 0.588001C19.805 0.980001 20.0007 1.45067 20 2V6C19.45 6 18.979 6.196 18.587 6.588C18.195 6.98 17.9993 7.45067 18 8C18 8.55 18.196 9.021 18.588 9.413C18.98 9.805 19.4507 10.0007 20 10V14C20 14.55 19.804 15.021 19.412 15.413C19.02 15.805 18.5493 16.0007 18 16Z"
                  :stroke="$route.path === '/invoicing/confirm-payment' ? '#5A9AE8' : '#38485C'" 
                  stroke-width="1.5" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"
                  :fill="$route.path === '/invoicing/confirm-payment' ? '#5A9AE8' : '#38485C'"
                  />
              </svg>
              <span :style="`color : ${$route.path === '/invoicing/confirm-payment' ? '#5A9AE8' : '#38485C'}`">Confirm Payment</span>
            </a>
          </li> -->
          <li class="sidebar link" v-if="viewInvoiceIgnored === true">
            <a @click="toInvoiceIgnoreListPage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M7.52734 13.3223L14.3209 13.3223" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'" stroke-width="2.26452" stroke-linecap="round"/>
                <path d="M7.52734 8.79395L10.358 8.79395" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'" stroke-width="2.26452" stroke-linecap="round"/>
                <path d="M7.52734 17.8516L12.0564 17.8516" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'" stroke-width="2.26452" stroke-linecap="round"/>
                <path d="M18.8517 13.3226V15.5871C18.8517 18.7897 18.8517 20.3909 17.8568 21.3858C16.8619 22.3807 15.2606 22.3807 12.0581 22.3807H9.79357C6.59105 22.3807 4.98979 22.3807 3.9949 21.3858C3 20.3909 3 18.7897 3 15.5871V8.79356C3 5.59105 3 3.98979 3.99489 2.9949C3.99489 2.9949 3.9949 2.99489 3.9949 2.99489C4.98979 2 6.59105 2 9.79357 2V2" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'" stroke-width="2.26452"/>
                <path d="M15.3164 2.99512L20.1202 7.7989" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'" stroke-width="2.26452" stroke-linecap="round"/>
                <path d="M20.1211 2.99512L15.3173 7.7989" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'" stroke-width="2.26452" stroke-linecap="round"/>
              </svg>
              <span :style="`color : ${$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'}`">Ignored Invoice</span>
            </a>
          </li>
        </ul>
      </div>
      <div id="collapseInvoice" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else-if="route != 'invoicing' && viewInvoicing === true && (viewPendingInvoice === true || viewInvoiceList === true || viewPaymentList === true || viewConfirmPayment === true)">
        <ul>
          <li class="sidebar link" v-if="viewPendingInvoice === true">
            <a @click="toInvoicePendingPage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 21" fill="none">
                <path 
                  d="M12 14.69V11H13.5V13.82L15.94 15.23L15.19 16.53L12 14.69ZM16.5 1.5L15 0L13.5 1.5L12 0L10.5 1.5L9 0L7.5 1.5L6 0L4.5 1.5L3 0L1.5 1.5L0 0L0 20L1.5 18.5L3 20L4.5 18.5L6 20L7.58 18.42C7.72 18.61 7.88 18.78 8.05 18.95C9.36192 20.2423 11.1302 20.9657 12.9717 20.9634C14.8133 20.9611 16.5797 20.2334 17.8885 18.9378C19.1972 17.6423 19.9427 15.8832 19.9636 14.0418C19.9845 12.2004 19.279 10.4249 18 9.1V0L16.5 1.5ZM8.1 9C7.5 9.57 7.03 10.25 6.67 11H3V9H8.1ZM6.07 13C6 13.33 6 13.66 6 14C6 14.34 6 14.67 6.07 15H3V13H6.07ZM15 7L3 7V5L15 5V7ZM17.85 14C17.85 14.64 17.73 15.27 17.5 15.86C17.24 16.44 16.88 17 16.43 17.43C16 17.88 15.44 18.24 14.86 18.5C14.27 18.73 13.64 18.85 13 18.85C10.32 18.85 8.15 16.68 8.15 14C8.15 12.71 8.66 11.5 9.57 10.57C10.5 9.66 11.71 9.15 13 9.15C15.67 9.15 17.85 11.32 17.85 14Z" 
                  :fill="$route.path === '/invoicing/pending' ? '#5A9AE8' : '#38485C'"
                />
              </svg>
              <span :style="`color : ${$route.path === '/invoicing/pending' ? '#5A9AE8' : '#38485C'}`">Pending Invoice</span>
              <span class="badge badge-danger badge-order pb-1" v-if="pendingInvoiceCount != '0'">
                {{ pendingInvoiceCount }}
              </span>
            </a>
          </li>
          <li class="sidebar link" v-if="viewInvoiceList === true">
            <a @click="toInvoiceListPage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                <path 
                  d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
                  :fill="$route.path === '/invoicing/list' ? '#5A9AE8' : '#38485C'"
                />
              </svg>
              <span :style="`color : ${$route.path === '/invoicing/list' ? '#5A9AE8' : '#38485C'}`">Invoice List</span>  
              <span class="badge badge-danger badge-order" v-if="pendingDocCompany != '0'">
                {{ openInvoiceCount }}
              </span>
            </a>
          </li>
          <!-- invoice submenu -->
          <!-- <li class="sidebar link" v-if="viewPaymentList === true">
            <a @click="toInvoicePaymentListPage()" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path 
                  d="M10 8.23C9.2 7.493 7.793 6.98 6.5 6.948M6.5 6.948C4.961 6.91 3.583 7.551 3.583 9.307C3.583 12.537 10 10.922 10 14.153C10 15.995 8.292 16.787 6.5 16.728M6.5 6.948V5M3 15.23C3.752 16.155 5.15 16.683 6.5 16.728M6.5 16.728L6.5 19M21 12H13M13 12L16.84 8M13 12L16.84 16" 
                  :stroke="$route.path === '/invoicing/payment-list' ? '#5A9AE8' : '#38485C'" 
                  stroke-width="1.5" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"
                  :fill="$route.path === '/invoicing/payments' ? '#5A9AE8' : '#38485C'"
                  />
              </svg>
              <span :style="`color : ${$route.path === '/invoicing/payments' ? '#5A9AE8' : '#38485C'}`">Payment List</span>
            </a>
          </li>
          <li class="sidebar link" v-if="viewConfirmPayment === true">
            <a @click="toInvoicePaymentConfirmationPage()" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path 
                  d="M10 13C10.2833 13 10.521 12.904 10.713 12.712C10.905 12.52 11.0007 12.2827 11 12C11 11.7167 10.904 11.479 10.712 11.287C10.52 11.095 10.2827 10.9993 10 11C9.71667 11 9.479 11.096 9.287 11.288C9.095 11.48 8.99934 11.7173 9 12C9 12.2833 9.096 12.521 9.288 12.713C9.48 12.905 9.71734 13.0007 10 13ZM10 9C10.2833 9 10.521 8.904 10.713 8.712C10.905 8.52 11.0007 8.28267 11 8C11 7.71667 10.904 7.479 10.712 7.287C10.52 7.095 10.2827 6.99934 10 7C9.71667 7 9.479 7.096 9.287 7.288C9.095 7.48 8.99934 7.71734 9 8C9 8.28334 9.096 8.521 9.288 8.713C9.48 8.905 9.71734 9.00067 10 9ZM10 5C10.2833 5 10.521 4.904 10.713 4.712C10.905 4.52 11.0007 4.28267 11 4C11 3.71667 10.904 3.479 10.712 3.287C10.52 3.095 10.2827 2.99934 10 3C9.71667 3 9.479 3.096 9.287 3.288C9.095 3.48 8.99934 3.71734 9 4C9 4.28334 9.096 4.521 9.288 4.713C9.48 4.905 9.71734 5.00067 10 5ZM18 16H2C1.45 16 0.979002 15.804 0.587002 15.412C0.195002 15.02 -0.000664969 14.5493 1.69779e-06 14L1.69779e-06 10C0.550002 10 1.021 9.804 1.413 9.412C1.805 9.02 2.00067 8.54934 2 8C2 7.45 1.804 6.979 1.412 6.587C1.02 6.195 0.549335 5.99934 1.69779e-06 6L1.69779e-06 2C1.69779e-06 1.45 0.196002 0.979002 0.588002 0.587002C0.980002 0.195002 1.45067 -0.000664969 2 1.69779e-06L18 1.69779e-06C18.55 1.69779e-06 19.021 0.196001 19.413 0.588001C19.805 0.980001 20.0007 1.45067 20 2V6C19.45 6 18.979 6.196 18.587 6.588C18.195 6.98 17.9993 7.45067 18 8C18 8.55 18.196 9.021 18.588 9.413C18.98 9.805 19.4507 10.0007 20 10V14C20 14.55 19.804 15.021 19.412 15.413C19.02 15.805 18.5493 16.0007 18 16Z"
                  :stroke="$route.path === '/invoicing/confirm-payment' ? '#5A9AE8' : '#38485C'" 
                  stroke-width="1.5" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"
                  :fill="$route.path === '/invoicing/confirm-payment' ? '#5A9AE8' : '#38485C'"
                  />
              </svg>
              <span :style="`color : ${$route.path === '/invoicing/confirm-payment' ? '#5A9AE8' : '#38485C'}`">Confirm Payment</span>
            </a>
          </li> -->
          <li class="sidebar link" v-if="viewInvoiceIgnored === true">
            <a @click="toInvoiceIgnoreListPage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M7.52734 13.3223L14.3209 13.3223" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'"  stroke-width="2.26452" stroke-linecap="round"/>
                <path d="M7.52734 8.79395L10.358 8.79395" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'" stroke-width="2.26452" stroke-linecap="round"/>
                <path d="M7.52734 17.8516L12.0564 17.8516" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'" stroke-width="2.26452" stroke-linecap="round"/>
                <path d="M18.8517 13.3226V15.5871C18.8517 18.7897 18.8517 20.3909 17.8568 21.3858C16.8619 22.3807 15.2606 22.3807 12.0581 22.3807H9.79357C6.59105 22.3807 4.98979 22.3807 3.9949 21.3858C3 20.3909 3 18.7897 3 15.5871V8.79356C3 5.59105 3 3.98979 3.99489 2.9949C3.99489 2.9949 3.9949 2.99489 3.9949 2.99489C4.98979 2 6.59105 2 9.79357 2V2" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'" stroke-width="2.26452"/>
                <path d="M15.3164 2.99512L20.1202 7.7989" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'" stroke-width="2.26452" stroke-linecap="round"/>
                <path d="M20.1211 2.99512L15.3173 7.7989" :stroke="$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'" stroke-width="2.26452" stroke-linecap="round"/>
              </svg>
              <span :style="`color : ${$route.path === '/invoicing/ignore' ? '#5A9AE8' : '#38485C'}`">Ignored Invoice</span>  
            </a>
          </li>
        </ul>
      </div>
      <!-- -->
      <!-- END OF INVOICING -->
      <!-- INSURANCE -->
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex link active" data-toggle="collapse" data-target="#collapseInsurance" v-if="route === 'insurance'  &&  viewNewInsurance === true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :fill="$route.path.split('/').includes('insurance') ? '#5A9AE8' : '#38485C'">
          <rect width="24" height="24" fill="none"/>
          <path d="M8.99166 3.42499C7.44451 3.92953 6.13373 4.36679 6.07786 4.39622C6.02629 4.42145 5.93604 4.51395 5.88447 4.59383C5.79851 4.73258 5.78992 4.80826 5.77702 5.51041L5.75983 6.27983H4.27285C2.60967 6.27983 2.57958 6.28403 2.38619 6.56993L2.28734 6.71288V17.779L2.07246 17.8757C1.73295 18.0313 1.36765 18.3887 1.18285 18.7587C1.03244 19.0488 1.01954 19.1077 1.00665 19.5071C0.989459 19.8687 1.00235 19.9822 1.08401 20.2176C1.26881 20.7642 1.75014 21.2309 2.32173 21.4117C2.58818 21.5 2.61397 21.5 12 21.5C21.386 21.5 21.4118 21.5 21.6783 21.4117C22.2499 21.2309 22.7312 20.7642 22.916 20.2176C22.9976 19.9822 23.0105 19.8687 22.9934 19.5071C22.9805 19.1077 22.9676 19.0488 22.8171 18.7587C22.6323 18.3887 22.2671 18.0313 21.9275 17.8757L21.7127 17.779V6.71288L21.6138 6.56993C21.4204 6.28403 21.3903 6.27983 19.7271 6.27983H18.2402L18.223 5.51041C18.2101 4.69054 18.1886 4.61485 17.9565 4.42145C17.819 4.30793 12.1762 2.4958 11.9742 2.50001C11.8797 2.50001 10.6076 2.89523 8.99166 3.42499ZM14.4797 4.62747L16.8993 5.41791V6.83061C16.8993 8.87398 16.8262 9.58033 16.5082 10.5263C15.8378 12.5108 14.2863 14.1716 12.3567 14.9578L11.9957 15.1092L11.6132 14.9452C9.39563 14.0076 7.76683 12.0526 7.2726 9.71908C7.13937 9.09682 7.1007 8.45354 7.1007 6.86845V5.41791L9.49878 4.63167C10.8139 4.20282 11.9312 3.84544 11.9785 3.84544C12.0258 3.84123 13.1518 4.19441 14.4797 4.62747ZM5.76843 7.92798C5.76843 8.54183 5.85438 9.43738 5.96612 9.97976C6.47754 12.4772 8.10634 14.6257 10.4099 15.8366C10.8611 16.0762 11.6734 16.4 11.9012 16.4378C12.1246 16.4715 12.5759 16.3201 13.3108 15.9711C14.2434 15.5212 15.004 14.9831 15.7218 14.2599C17.4021 12.5655 18.2273 10.4717 18.2316 7.90695V7.58321H20.3804V17.6739H3.61961V7.58321H5.76843V7.92798ZM8.74669 19.4903C8.75958 19.7762 8.78537 20.0495 8.80256 20.1041L8.82835 20.1966L5.74694 20.1882L2.66983 20.1756L2.49793 19.999C2.35181 19.8434 2.33032 19.7972 2.33032 19.6164C2.33032 19.3641 2.45925 19.1581 2.67413 19.053C2.81166 18.9815 3.05232 18.9773 5.77273 18.9773H8.7209L8.74669 19.4903ZM13.9339 19.3221C13.9339 19.7467 13.8394 19.9738 13.6245 20.1041C13.4784 20.1924 13.4311 20.1966 12 20.1966C10.5689 20.1966 10.5216 20.1924 10.3755 20.1041C10.1606 19.9738 10.0661 19.7467 10.0661 19.3221V18.9773H13.9339V19.3221ZM21.3259 19.053C21.5408 19.1581 21.6697 19.3641 21.6697 19.6164C21.6697 19.7972 21.6482 19.8434 21.5021 19.999L21.3302 20.1756L18.2531 20.1882L15.1717 20.1966L15.1974 20.0831C15.2146 20.0158 15.2404 19.7425 15.2533 19.4692L15.2748 18.9773H18.2273C20.9477 18.9773 21.1883 18.9815 21.3259 19.053Z" :fill="$route.path.split('/').includes('insurance') ? '#5A9AE8' : '#38485C'"/>
          <path d="M13.9734 7.43906C13.9359 7.45313 13.2516 7.86563 12.45 8.35313C11.4234 8.97656 10.9828 9.22031 10.95 9.1875C10.9219 9.15937 10.7625 8.95781 10.5937 8.73281C10.425 8.50781 10.2328 8.2875 10.1672 8.24062C9.85312 8.00625 9.32343 8.12813 9.14531 8.47969C9.03749 8.68125 9.01874 8.925 9.08906 9.1125C9.18281 9.34687 10.3078 10.8141 10.4391 10.8656C10.6875 10.9641 10.8094 10.9734 10.9969 10.9078C11.3109 10.8 14.7469 8.68125 14.8406 8.54063C15.0375 8.24063 14.9484 7.74375 14.6625 7.53281C14.5359 7.43906 14.1047 7.37813 13.9734 7.43906Z" :fill="$route.path.split('/').includes('insurance') ? '#5A9AE8' : '#38485C'"/>
        </svg>
        <span class="menu-title">Insurance</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex link" data-toggle="collapse" data-target="#collapseInsurance" v-else-if="route != 'insurance'  && viewNewInsurance === true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :fill="$route.path.split('/').includes('insurance') ? '#5A9AE8' : '#38485C'">
          <rect width="24" height="24" fill="none"/>
          <path d="M8.99166 3.42499C7.44451 3.92953 6.13373 4.36679 6.07786 4.39622C6.02629 4.42145 5.93604 4.51395 5.88447 4.59383C5.79851 4.73258 5.78992 4.80826 5.77702 5.51041L5.75983 6.27983H4.27285C2.60967 6.27983 2.57958 6.28403 2.38619 6.56993L2.28734 6.71288V17.779L2.07246 17.8757C1.73295 18.0313 1.36765 18.3887 1.18285 18.7587C1.03244 19.0488 1.01954 19.1077 1.00665 19.5071C0.989459 19.8687 1.00235 19.9822 1.08401 20.2176C1.26881 20.7642 1.75014 21.2309 2.32173 21.4117C2.58818 21.5 2.61397 21.5 12 21.5C21.386 21.5 21.4118 21.5 21.6783 21.4117C22.2499 21.2309 22.7312 20.7642 22.916 20.2176C22.9976 19.9822 23.0105 19.8687 22.9934 19.5071C22.9805 19.1077 22.9676 19.0488 22.8171 18.7587C22.6323 18.3887 22.2671 18.0313 21.9275 17.8757L21.7127 17.779V6.71288L21.6138 6.56993C21.4204 6.28403 21.3903 6.27983 19.7271 6.27983H18.2402L18.223 5.51041C18.2101 4.69054 18.1886 4.61485 17.9565 4.42145C17.819 4.30793 12.1762 2.4958 11.9742 2.50001C11.8797 2.50001 10.6076 2.89523 8.99166 3.42499ZM14.4797 4.62747L16.8993 5.41791V6.83061C16.8993 8.87398 16.8262 9.58033 16.5082 10.5263C15.8378 12.5108 14.2863 14.1716 12.3567 14.9578L11.9957 15.1092L11.6132 14.9452C9.39563 14.0076 7.76683 12.0526 7.2726 9.71908C7.13937 9.09682 7.1007 8.45354 7.1007 6.86845V5.41791L9.49878 4.63167C10.8139 4.20282 11.9312 3.84544 11.9785 3.84544C12.0258 3.84123 13.1518 4.19441 14.4797 4.62747ZM5.76843 7.92798C5.76843 8.54183 5.85438 9.43738 5.96612 9.97976C6.47754 12.4772 8.10634 14.6257 10.4099 15.8366C10.8611 16.0762 11.6734 16.4 11.9012 16.4378C12.1246 16.4715 12.5759 16.3201 13.3108 15.9711C14.2434 15.5212 15.004 14.9831 15.7218 14.2599C17.4021 12.5655 18.2273 10.4717 18.2316 7.90695V7.58321H20.3804V17.6739H3.61961V7.58321H5.76843V7.92798ZM8.74669 19.4903C8.75958 19.7762 8.78537 20.0495 8.80256 20.1041L8.82835 20.1966L5.74694 20.1882L2.66983 20.1756L2.49793 19.999C2.35181 19.8434 2.33032 19.7972 2.33032 19.6164C2.33032 19.3641 2.45925 19.1581 2.67413 19.053C2.81166 18.9815 3.05232 18.9773 5.77273 18.9773H8.7209L8.74669 19.4903ZM13.9339 19.3221C13.9339 19.7467 13.8394 19.9738 13.6245 20.1041C13.4784 20.1924 13.4311 20.1966 12 20.1966C10.5689 20.1966 10.5216 20.1924 10.3755 20.1041C10.1606 19.9738 10.0661 19.7467 10.0661 19.3221V18.9773H13.9339V19.3221ZM21.3259 19.053C21.5408 19.1581 21.6697 19.3641 21.6697 19.6164C21.6697 19.7972 21.6482 19.8434 21.5021 19.999L21.3302 20.1756L18.2531 20.1882L15.1717 20.1966L15.1974 20.0831C15.2146 20.0158 15.2404 19.7425 15.2533 19.4692L15.2748 18.9773H18.2273C20.9477 18.9773 21.1883 18.9815 21.3259 19.053Z" :fill="$route.path.split('/').includes('insurance') ? '#5A9AE8' : '#38485C'"/>
          <path d="M13.9734 7.43906C13.9359 7.45313 13.2516 7.86563 12.45 8.35313C11.4234 8.97656 10.9828 9.22031 10.95 9.1875C10.9219 9.15937 10.7625 8.95781 10.5937 8.73281C10.425 8.50781 10.2328 8.2875 10.1672 8.24062C9.85312 8.00625 9.32343 8.12813 9.14531 8.47969C9.03749 8.68125 9.01874 8.925 9.08906 9.1125C9.18281 9.34687 10.3078 10.8141 10.4391 10.8656C10.6875 10.9641 10.8094 10.9734 10.9969 10.9078C11.3109 10.8 14.7469 8.68125 14.8406 8.54063C15.0375 8.24063 14.9484 7.74375 14.6625 7.53281C14.5359 7.43906 14.1047 7.37813 13.9734 7.43906Z" :fill="$route.path.split('/').includes('insurance') ? '#5A9AE8' : '#38485C'"/>
        </svg>
        <span class="menu-title">Insurance</span>
        <div class="right-arrow"><i class="fas fa-angle-down"></i></div>
      </a>
      <div id="collapseInsurance" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="route === 'insurance' && (viewNewInsuranceBatch === true || viewNewInsurancePendingDeclare === true || viewNewInsuranceVendor === true)">
        <ul>
          <li class="sidebar link" v-if="viewNewInsurance === true && viewNewInsuranceVendor === true">
            <a @click="toInsuranceVendorPage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 25" :fill="$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'">
                <g clip-path="url(#clip0_999_28870)">
                  <path d="M11.1582 0.752817C10.0479 1.04289 9.16771 1.9431 8.87264 3.07837C8.77262 3.46346 8.77262 4.27366 8.87765 4.67375C9.15271 5.75901 10.0579 6.68423 11.1232 6.9793C11.3682 7.04432 11.3632 7.04432 10.7231 7.04932C9.70784 7.05432 9.23273 7.22436 8.6826 7.76449C8.48255 7.95954 8.33752 8.16959 8.20749 8.43965L8.02244 8.82975L8.00744 10.09C7.99744 10.8502 8.01244 11.4204 8.04245 11.5404C8.12247 11.8355 8.36752 12.1805 8.63259 12.3756C9.01268 12.6507 9.29775 12.7057 10.313 12.7057H11.1982V13.4809V14.256H7.49732C3.91146 14.256 3.78643 14.261 3.60139 14.3561C3.2363 14.5411 3.19629 14.6711 3.19629 15.6514C3.19629 16.5966 3.2213 16.6916 3.49636 16.9217C3.94647 17.3018 4.66664 17.0417 4.79167 16.4516C4.82168 16.3165 4.84668 16.1365 4.84668 16.0565V15.9064H8.02244H11.1982V16.2065C11.1982 16.5516 11.2782 16.7366 11.4983 16.9217C11.9484 17.3018 12.6686 17.0417 12.7936 16.4516C12.8236 16.3165 12.8486 16.1365 12.8486 16.0565V15.9064H16.0244H19.2001V16.2065C19.2001 16.5516 19.2801 16.7366 19.5002 16.9217C19.8053 17.1767 20.2354 17.1567 20.5504 16.8767C20.8105 16.6416 20.8705 16.3715 20.8405 15.4963C20.8255 14.8662 20.8155 14.8062 20.6905 14.6211C20.4354 14.236 20.6555 14.256 16.5295 14.256H12.8486V13.4809V12.7057H13.7138C14.359 12.7057 14.649 12.6857 14.8491 12.6257C15.3542 12.4756 15.6593 12.2056 15.8893 11.7054C16.0043 11.4554 16.0194 11.3604 16.0394 10.5552C16.0794 8.98478 15.9143 8.35963 15.3142 7.76449C14.7641 7.22436 14.2889 7.05432 13.2737 7.04932C12.6335 7.04432 12.6285 7.04432 12.8736 6.9793C13.9339 6.68423 14.8491 5.75401 15.1241 4.67875C15.2292 4.27366 15.2292 3.46346 15.1241 3.05337C14.8991 2.18316 14.2539 1.38297 13.4337 0.967869C12.8136 0.657795 11.8734 0.567774 11.1582 0.752817ZM12.4635 2.3732C13.1087 2.56825 13.5538 3.1884 13.5538 3.89357C13.5538 4.8838 12.5585 5.65399 11.6233 5.37892C10.8981 5.16887 10.448 4.60374 10.448 3.89857C10.448 3.40345 10.563 3.12838 10.9181 2.7783C11.3632 2.33319 11.8834 2.19816 12.4635 2.3732ZM14.0389 8.84475C14.3389 9.0598 14.369 9.18483 14.389 10.1651L14.409 11.0553H12.0284H9.64783V10.1351C9.64783 9.26985 9.65283 9.20984 9.76286 9.0548C9.82287 8.96478 9.9529 8.84975 10.0479 8.79474C10.213 8.70972 10.343 8.70472 12.0484 8.71472C13.8688 8.72972 13.8738 8.72972 14.0389 8.84475Z" :fill="$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'"/>
                  <path d="M2.55106 18.3368C1.88591 18.5168 1.31577 18.9969 1.0107 19.6371L0.820652 20.0322L0.805648 21.3725C0.790644 22.6328 0.795646 22.7328 0.895669 23.0379C1.11072 23.688 1.54582 24.1732 2.15597 24.4582C2.64109 24.6833 2.93616 24.7183 4.19646 24.6983C5.23171 24.6783 5.34673 24.6683 5.6218 24.5583C6.35697 24.2732 6.81208 23.8081 7.08215 23.0779C7.19217 22.7728 7.20718 22.6328 7.23218 21.8326C7.26719 20.6373 7.20718 20.1072 6.97712 19.6221C6.67205 18.9869 6.09691 18.5118 5.42175 18.3318C5.01165 18.2267 2.94616 18.2317 2.55106 18.3368ZM3.20622 20.2872C3.22123 20.6573 3.22623 20.6723 3.43128 20.8574C3.75135 21.1624 4.18646 21.1875 4.49653 20.9224C4.70658 20.7473 4.7916 20.5623 4.83161 20.2072C4.84661 20.0422 4.88162 19.9071 4.90663 19.9071C5.04666 19.9071 5.32173 20.0972 5.43675 20.2722C5.57179 20.4773 5.57179 20.4773 5.57179 21.4825C5.57179 22.4728 5.57179 22.4928 5.44676 22.6728C5.2167 23.0129 5.04166 23.0579 3.99641 23.0579C2.96116 23.0579 2.77112 23.0129 2.56107 22.6928C2.45104 22.5328 2.44604 22.4828 2.44604 21.4775C2.44604 20.4523 2.44604 20.4273 2.56607 20.2522C2.6861 20.0772 2.94616 19.9121 3.1012 19.9071C3.17121 19.9071 3.19122 19.9772 3.20622 20.2872Z" :fill="$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'"/>
                  <path d="M10.5531 18.3368C9.88794 18.5169 9.31781 18.997 9.01273 19.6371L8.82269 20.0322L8.80769 21.3525C8.79268 22.5578 8.79768 22.6979 8.89271 23.0029C9.08775 23.6431 9.52786 24.1582 10.123 24.4433C10.6381 24.6833 10.9182 24.7183 12.1985 24.6983C13.2337 24.6783 13.3488 24.6683 13.6238 24.5583C14.5241 24.2082 15.0942 23.4831 15.1992 22.5478C15.2642 22.0177 15.2592 20.8424 15.1992 20.3573C15.0742 19.3871 14.359 18.5769 13.4238 18.3318C13.0137 18.2268 10.9482 18.2318 10.5531 18.3368ZM11.2083 20.2873C11.2233 20.6574 11.2283 20.6724 11.4333 20.8574C11.7534 21.1625 12.1885 21.1875 12.4986 20.9224C12.7086 20.7474 12.7936 20.5624 12.8336 20.2073C12.8486 20.0422 12.8837 19.9072 12.9087 19.9072C13.0487 19.9072 13.3238 20.0972 13.4388 20.2723C13.5738 20.4773 13.5738 20.4773 13.5738 21.4826C13.5738 22.4728 13.5738 22.4928 13.4488 22.6729C13.2187 23.0129 13.0437 23.058 11.9984 23.058C11.1783 23.058 11.0582 23.0479 10.8782 22.9579C10.4881 22.7629 10.4731 22.7229 10.4581 21.5126C10.4431 20.4523 10.4431 20.4423 10.5631 20.2623C10.6881 20.0772 10.9432 19.9122 11.1032 19.9072C11.1732 19.9072 11.1933 19.9772 11.2083 20.2873Z" :fill="$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'"/>
                  <path d="M18.52 18.3518C17.8599 18.5419 17.3348 18.987 17.0197 19.6371L16.8246 20.0322L16.8096 21.3525C16.7946 22.5578 16.7996 22.6979 16.8947 23.0029C17.0897 23.6431 17.5298 24.1582 18.125 24.4433C18.6401 24.6833 18.9201 24.7183 20.2004 24.6983C21.2307 24.6783 21.3507 24.6683 21.6258 24.5583C22.506 24.2182 23.0861 23.4981 23.2012 22.6028C23.2612 22.1227 23.2612 20.8374 23.2012 20.3573C23.0761 19.3871 22.361 18.5769 21.4257 18.3318C20.9806 18.2168 18.9451 18.2318 18.52 18.3518ZM19.2002 20.2073C19.2002 20.5524 19.2802 20.7374 19.5003 20.9224C20.0654 21.3976 20.8506 20.9124 20.8506 20.0872C20.8506 19.9072 20.8556 19.8972 20.9856 19.9322C21.1807 19.9772 21.3907 20.1423 21.4908 20.3223C21.5608 20.4573 21.5758 20.6274 21.5758 21.4826C21.5758 22.4378 21.5708 22.4928 21.4607 22.6679C21.2507 23.0029 21.0557 23.058 20.0104 23.058C19.0052 23.058 18.8801 23.0329 18.6251 22.7629L18.475 22.6028L18.46 21.5226C18.445 20.4523 18.445 20.4473 18.5651 20.2623C18.6901 20.0772 18.9451 19.9122 19.1152 19.9072C19.1852 19.9072 19.2002 19.9522 19.2002 20.2073Z" :fill="$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'"/>
                </g>
                <defs>
                  <clipPath id="clip0_999_28870">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.657227)"/>
                  </clipPath>
                </defs>
              </svg>
              <span :style="`color : ${$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'}`">Vendors</span>  
             
            </a>
          </li>
          <li class="sidebar link" v-if="viewNewInsurance === true && viewNewInsurancePendingDeclare === true">
            <a @click="toInsurancePendingDeclarePage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M5.55937 1.20745C4.25996 1.25225 3.60465 1.45389 3.06136 1.96917C2.57688 2.42845 2.33604 3.01655 2.23522 3.97711C2.18201 4.49239 2.18201 16.6912 2.23522 17.1813C2.33324 18.0775 2.54327 18.6263 2.94934 19.0604C3.36661 19.5085 3.88189 19.7493 4.67163 19.8698C5.04689 19.9286 6.27069 19.9678 7.76614 19.9678H9.01795V19.1556V18.3435H7.79415C6.25389 18.3407 5.1365 18.3043 4.80325 18.2455C4.06952 18.1139 3.9043 17.8506 3.83709 16.6968C3.80068 16.1059 3.80348 5.04969 3.83709 4.45319C3.8931 3.50103 4.01352 3.18457 4.39158 3.01655C4.65202 2.89893 4.95727 2.85972 5.86742 2.82612C6.9092 2.78691 12.5213 2.80931 12.8966 2.85412C13.8404 2.96614 14.0336 3.15937 14.1456 4.10313C14.1652 4.25995 14.182 5.52016 14.1904 7.46929L14.2044 10.5862H15.0137H15.8231V7.93137C15.8203 3.83428 15.7867 3.37501 15.431 2.64689C15.0502 1.86556 14.3864 1.42868 13.3419 1.27466C13.1766 1.24945 12.7202 1.21865 12.3253 1.20464C11.4964 1.17384 6.43032 1.17664 5.55937 1.20745Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M7.04897 5.62937L6.38526 6.27908L6.25644 6.16146C6.18643 6.09705 6.06041 6.01303 5.97359 5.97383C5.84197 5.91222 5.78876 5.90381 5.63193 5.91502C5.4163 5.93182 5.30708 5.97943 5.16706 6.12505C4.95982 6.33789 4.92902 6.73835 5.09424 6.9988C5.14185 7.07441 5.35189 7.30125 5.55912 7.50288C5.98199 7.91455 6.13322 8.00977 6.37126 8.00977C6.67651 8.00697 6.85854 7.86694 7.8443 6.86998C8.64524 6.05784 8.70965 5.96823 8.70965 5.67418C8.70965 5.48935 8.63963 5.29891 8.53322 5.1869C8.41 5.05527 8.26717 5.00206 7.98153 4.99086L7.71548 4.98246L7.04897 5.62937Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M9.73744 6.22874C9.28377 6.39117 9.06533 6.90366 9.26417 7.34333C9.33138 7.49455 9.4938 7.65418 9.65903 7.73539C9.78785 7.7998 9.79625 7.7998 11.0061 7.7998H12.2243L12.3671 7.72419C12.6471 7.57577 12.804 7.31812 12.804 7.00167C12.804 6.75243 12.7227 6.562 12.5463 6.40517C12.3111 6.19234 12.2803 6.18954 10.9809 6.18954C10.0987 6.19234 9.82146 6.20074 9.73744 6.22874Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M6.1694 9.85461C5.81374 9.97783 5.62891 10.2439 5.62891 10.6387C5.62891 10.8768 5.71292 11.0644 5.89215 11.2212C6.13859 11.4369 5.95656 11.4257 9.00347 11.4257C12.0392 11.4257 11.8711 11.4369 12.1064 11.2296C12.1848 11.1596 12.2576 11.0588 12.308 10.9468C12.3752 10.7956 12.3836 10.748 12.3724 10.5715C12.3556 10.3223 12.252 10.1151 12.0728 9.98063C11.8319 9.7958 11.9496 9.8014 8.99227 9.8014C6.49705 9.8042 6.30662 9.807 6.1694 9.85461Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M15.1369 12.8431C13.8711 13.0783 12.8685 13.6468 12.0284 14.6102C11.5215 15.1899 11.1322 15.9404 10.9418 16.7049C10.8466 17.083 10.813 17.321 10.7934 17.7607C10.7318 19.0545 11.1266 20.2671 11.9248 21.2585C12.1684 21.5609 12.6865 22.0482 12.9973 22.2695C13.4818 22.6139 14.1231 22.908 14.7168 23.0564C15.1761 23.1712 15.4141 23.1992 16.005 23.1992C16.4951 23.1992 16.5763 23.1936 16.6631 23.1488C16.904 23.0228 16.9992 22.8604 16.9992 22.5775C16.9992 22.4039 16.988 22.3675 16.9096 22.2471C16.7556 22.023 16.6855 22.0006 16.019 21.981C15.7026 21.9698 15.3749 21.9474 15.2909 21.9306C13.7171 21.6114 12.5297 20.4912 12.1208 18.9369C12.0368 18.6205 12.034 18.5868 12.0312 18.0072C12.0312 17.4751 12.0368 17.377 12.0928 17.1586C12.2944 16.3493 12.6361 15.736 13.1934 15.1815C13.647 14.7278 14.1763 14.3974 14.7588 14.2069C15.2181 14.0557 15.4225 14.0249 15.991 14.0221C16.4363 14.0221 16.5483 14.0305 16.7864 14.0837C17.5145 14.2517 18.1446 14.571 18.6935 15.0527C18.8419 15.1843 19.1556 15.5371 19.178 15.596C19.1808 15.61 18.9987 15.6296 18.7719 15.6408C18.5451 15.652 18.3182 15.6772 18.2734 15.694C18.1586 15.7416 18.0158 15.9096 17.9822 16.0384C17.9065 16.3101 17.999 16.6013 18.2062 16.7385L18.3238 16.817L19.1668 16.8254C19.9397 16.8338 20.0209 16.8282 20.1917 16.7777C20.637 16.6433 21.0067 16.2709 21.1439 15.8256C21.1943 15.6688 21.1999 15.5651 21.1999 14.8538C21.1999 13.9745 21.1943 13.9437 21.0291 13.7868C20.903 13.6692 20.8134 13.6384 20.5866 13.6384C20.427 13.6384 20.3794 13.6496 20.2701 13.7196C20.0909 13.8345 20.0293 13.9745 20.0069 14.3301L19.9873 14.613L19.6904 14.3133C19.528 14.1481 19.318 13.9577 19.2256 13.8849C18.5899 13.4004 17.9009 13.0811 17.0944 12.8935C16.7864 12.8235 16.7079 12.8151 16.061 12.8095C15.529 12.8011 15.3077 12.8095 15.1369 12.8431Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M6.1694 13.6606C5.81374 13.7866 5.62891 14.0527 5.62891 14.4475C5.62891 14.6856 5.71292 14.8732 5.89215 15.03C6.12739 15.2373 6.13299 15.2373 7.52202 15.2289C8.72062 15.2205 8.75423 15.2177 8.86345 15.1589C9.25551 14.9488 9.41794 14.4587 9.23031 14.0723C9.14349 13.9014 9.00627 13.767 8.82424 13.683C8.70102 13.627 8.64781 13.6242 7.50522 13.6186C6.41864 13.6102 6.30102 13.6158 6.1694 13.6606Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M20.3401 18.4102C20.0852 18.4914 19.9676 18.6538 19.8696 19.0627C19.7688 19.4856 19.8612 19.7656 20.144 19.9C20.4017 20.0204 20.6901 19.9728 20.8721 19.7796C21.0402 19.6004 21.169 18.9955 21.0906 18.7574C21.043 18.6118 20.8777 18.4606 20.7125 18.413C20.5473 18.3626 20.4941 18.3626 20.3401 18.4102Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M19.5052 20.1749C19.3736 20.2225 19.0768 20.5278 18.9563 20.7378C18.7939 21.0207 18.8695 21.3735 19.1328 21.5527C19.2868 21.6564 19.424 21.6844 19.6144 21.6452C19.7405 21.6172 19.7825 21.5892 19.9729 21.3931C20.3426 21.0123 20.4182 20.7406 20.239 20.4354C20.0989 20.1973 19.7685 20.0797 19.5052 20.1749Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M17.9707 21.4905C17.7383 21.5885 17.5059 21.7314 17.4302 21.8294C17.2118 22.115 17.3126 22.5855 17.6263 22.7367C17.8419 22.8431 18.0351 22.8235 18.3376 22.6723C18.7241 22.4791 18.8193 22.3783 18.8613 22.129C18.8921 21.9358 18.8305 21.7426 18.6933 21.6025C18.5 21.4121 18.2564 21.3729 17.9707 21.4905Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
              </svg>
              <span :style="`color : ${$route.path === '/insurance/pending' ? '#5A9AE8' : '#38485C'}`">Pending Declare</span>  
              <span class="badge badge-danger badge-order pb-1" v-if="pendingInsuranceCount != '0'">
                {{ pendingInsuranceCount }}
              </span>
            </a>
          </li>
          <li class="sidebar link" v-if="viewNewInsurance === true && viewNewInsuranceBatch === true">
            <a @click="toInsuranceBatchListPage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 21 25" fill="none">
                <path d="M18.7022 6.44164L12.7878 3.9069C12.2847 3.69129 11.7153 3.69129 11.2122 3.9069L5.29778 6.44164C4.47855 6.79274 3.99051 7.64358 4.10106 8.528L4.71405 13.4319C4.9342 15.1931 5.81517 16.8049 7.1787 17.9412L10.7196 20.892C11.4613 21.51 12.5387 21.51 13.2804 20.892L16.8213 17.9412C18.1848 16.8049 19.0658 15.1931 19.286 13.4319L19.8989 8.528C20.0095 7.64358 19.5215 6.79274 18.7022 6.44164Z" :stroke="$route.path === '/insurance/batch' ? '#5A9AE8' : '#38485C'" stroke-width="2" stroke-linecap="round"/>
                <path d="M9 12.6572L11.5687 15.226C11.7918 15.4491 12.1633 15.4123 12.3383 15.1498L16 9.65723" :stroke="$route.path === '/insurance/batch' ? '#5A9AE8' : '#38485C'" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <span :style="`color : ${$route.path === '/insurance/batch' ? '#5A9AE8' : '#38485C'}`">Batch Insurance</span>  
              <span class="badge badge-danger badge-order" v-if="batchInsuranceCount != '0'">
                {{ batchInsuranceCount }}
              </span>
            </a>
          </li>
          <li class="sidebar link" v-if="viewNewInsurance === true">
            <a @click="toInsurancePolisListPage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512" fill="none">
                <path d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"  :fill="$route.path === '/insurance/polis' ? '#4096EC' : '#38485C'"/>
              </svg>
              <span :style="`color : ${$route.path === '/insurance/polis' ? '#5A9AE8' : '#38485C'}`">Polis List</span>  
            </a>
          </li>
        </ul>
      </div>
      <div id="collapseInsurance" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else-if="route != 'insurance' && (viewNewInsuranceBatch === true || viewNewInsurancePendingDeclare === true || viewNewInsuranceVendor === true)">
        <ul>
          <li class="sidebar link" v-if="viewNewInsurance === true && viewNewInsuranceVendor === true">
            <a @click="toInsuranceVendorPage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 25" :fill="$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'">
                <g clip-path="url(#clip0_999_28870)">
                  <path d="M11.1582 0.752817C10.0479 1.04289 9.16771 1.9431 8.87264 3.07837C8.77262 3.46346 8.77262 4.27366 8.87765 4.67375C9.15271 5.75901 10.0579 6.68423 11.1232 6.9793C11.3682 7.04432 11.3632 7.04432 10.7231 7.04932C9.70784 7.05432 9.23273 7.22436 8.6826 7.76449C8.48255 7.95954 8.33752 8.16959 8.20749 8.43965L8.02244 8.82975L8.00744 10.09C7.99744 10.8502 8.01244 11.4204 8.04245 11.5404C8.12247 11.8355 8.36752 12.1805 8.63259 12.3756C9.01268 12.6507 9.29775 12.7057 10.313 12.7057H11.1982V13.4809V14.256H7.49732C3.91146 14.256 3.78643 14.261 3.60139 14.3561C3.2363 14.5411 3.19629 14.6711 3.19629 15.6514C3.19629 16.5966 3.2213 16.6916 3.49636 16.9217C3.94647 17.3018 4.66664 17.0417 4.79167 16.4516C4.82168 16.3165 4.84668 16.1365 4.84668 16.0565V15.9064H8.02244H11.1982V16.2065C11.1982 16.5516 11.2782 16.7366 11.4983 16.9217C11.9484 17.3018 12.6686 17.0417 12.7936 16.4516C12.8236 16.3165 12.8486 16.1365 12.8486 16.0565V15.9064H16.0244H19.2001V16.2065C19.2001 16.5516 19.2801 16.7366 19.5002 16.9217C19.8053 17.1767 20.2354 17.1567 20.5504 16.8767C20.8105 16.6416 20.8705 16.3715 20.8405 15.4963C20.8255 14.8662 20.8155 14.8062 20.6905 14.6211C20.4354 14.236 20.6555 14.256 16.5295 14.256H12.8486V13.4809V12.7057H13.7138C14.359 12.7057 14.649 12.6857 14.8491 12.6257C15.3542 12.4756 15.6593 12.2056 15.8893 11.7054C16.0043 11.4554 16.0194 11.3604 16.0394 10.5552C16.0794 8.98478 15.9143 8.35963 15.3142 7.76449C14.7641 7.22436 14.2889 7.05432 13.2737 7.04932C12.6335 7.04432 12.6285 7.04432 12.8736 6.9793C13.9339 6.68423 14.8491 5.75401 15.1241 4.67875C15.2292 4.27366 15.2292 3.46346 15.1241 3.05337C14.8991 2.18316 14.2539 1.38297 13.4337 0.967869C12.8136 0.657795 11.8734 0.567774 11.1582 0.752817ZM12.4635 2.3732C13.1087 2.56825 13.5538 3.1884 13.5538 3.89357C13.5538 4.8838 12.5585 5.65399 11.6233 5.37892C10.8981 5.16887 10.448 4.60374 10.448 3.89857C10.448 3.40345 10.563 3.12838 10.9181 2.7783C11.3632 2.33319 11.8834 2.19816 12.4635 2.3732ZM14.0389 8.84475C14.3389 9.0598 14.369 9.18483 14.389 10.1651L14.409 11.0553H12.0284H9.64783V10.1351C9.64783 9.26985 9.65283 9.20984 9.76286 9.0548C9.82287 8.96478 9.9529 8.84975 10.0479 8.79474C10.213 8.70972 10.343 8.70472 12.0484 8.71472C13.8688 8.72972 13.8738 8.72972 14.0389 8.84475Z" :fill="$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'"/>
                  <path d="M2.55106 18.3368C1.88591 18.5168 1.31577 18.9969 1.0107 19.6371L0.820652 20.0322L0.805648 21.3725C0.790644 22.6328 0.795646 22.7328 0.895669 23.0379C1.11072 23.688 1.54582 24.1732 2.15597 24.4582C2.64109 24.6833 2.93616 24.7183 4.19646 24.6983C5.23171 24.6783 5.34673 24.6683 5.6218 24.5583C6.35697 24.2732 6.81208 23.8081 7.08215 23.0779C7.19217 22.7728 7.20718 22.6328 7.23218 21.8326C7.26719 20.6373 7.20718 20.1072 6.97712 19.6221C6.67205 18.9869 6.09691 18.5118 5.42175 18.3318C5.01165 18.2267 2.94616 18.2317 2.55106 18.3368ZM3.20622 20.2872C3.22123 20.6573 3.22623 20.6723 3.43128 20.8574C3.75135 21.1624 4.18646 21.1875 4.49653 20.9224C4.70658 20.7473 4.7916 20.5623 4.83161 20.2072C4.84661 20.0422 4.88162 19.9071 4.90663 19.9071C5.04666 19.9071 5.32173 20.0972 5.43675 20.2722C5.57179 20.4773 5.57179 20.4773 5.57179 21.4825C5.57179 22.4728 5.57179 22.4928 5.44676 22.6728C5.2167 23.0129 5.04166 23.0579 3.99641 23.0579C2.96116 23.0579 2.77112 23.0129 2.56107 22.6928C2.45104 22.5328 2.44604 22.4828 2.44604 21.4775C2.44604 20.4523 2.44604 20.4273 2.56607 20.2522C2.6861 20.0772 2.94616 19.9121 3.1012 19.9071C3.17121 19.9071 3.19122 19.9772 3.20622 20.2872Z" :fill="$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'"/>
                  <path d="M10.5531 18.3368C9.88794 18.5169 9.31781 18.997 9.01273 19.6371L8.82269 20.0322L8.80769 21.3525C8.79268 22.5578 8.79768 22.6979 8.89271 23.0029C9.08775 23.6431 9.52786 24.1582 10.123 24.4433C10.6381 24.6833 10.9182 24.7183 12.1985 24.6983C13.2337 24.6783 13.3488 24.6683 13.6238 24.5583C14.5241 24.2082 15.0942 23.4831 15.1992 22.5478C15.2642 22.0177 15.2592 20.8424 15.1992 20.3573C15.0742 19.3871 14.359 18.5769 13.4238 18.3318C13.0137 18.2268 10.9482 18.2318 10.5531 18.3368ZM11.2083 20.2873C11.2233 20.6574 11.2283 20.6724 11.4333 20.8574C11.7534 21.1625 12.1885 21.1875 12.4986 20.9224C12.7086 20.7474 12.7936 20.5624 12.8336 20.2073C12.8486 20.0422 12.8837 19.9072 12.9087 19.9072C13.0487 19.9072 13.3238 20.0972 13.4388 20.2723C13.5738 20.4773 13.5738 20.4773 13.5738 21.4826C13.5738 22.4728 13.5738 22.4928 13.4488 22.6729C13.2187 23.0129 13.0437 23.058 11.9984 23.058C11.1783 23.058 11.0582 23.0479 10.8782 22.9579C10.4881 22.7629 10.4731 22.7229 10.4581 21.5126C10.4431 20.4523 10.4431 20.4423 10.5631 20.2623C10.6881 20.0772 10.9432 19.9122 11.1032 19.9072C11.1732 19.9072 11.1933 19.9772 11.2083 20.2873Z" :fill="$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'"/>
                  <path d="M18.52 18.3518C17.8599 18.5419 17.3348 18.987 17.0197 19.6371L16.8246 20.0322L16.8096 21.3525C16.7946 22.5578 16.7996 22.6979 16.8947 23.0029C17.0897 23.6431 17.5298 24.1582 18.125 24.4433C18.6401 24.6833 18.9201 24.7183 20.2004 24.6983C21.2307 24.6783 21.3507 24.6683 21.6258 24.5583C22.506 24.2182 23.0861 23.4981 23.2012 22.6028C23.2612 22.1227 23.2612 20.8374 23.2012 20.3573C23.0761 19.3871 22.361 18.5769 21.4257 18.3318C20.9806 18.2168 18.9451 18.2318 18.52 18.3518ZM19.2002 20.2073C19.2002 20.5524 19.2802 20.7374 19.5003 20.9224C20.0654 21.3976 20.8506 20.9124 20.8506 20.0872C20.8506 19.9072 20.8556 19.8972 20.9856 19.9322C21.1807 19.9772 21.3907 20.1423 21.4908 20.3223C21.5608 20.4573 21.5758 20.6274 21.5758 21.4826C21.5758 22.4378 21.5708 22.4928 21.4607 22.6679C21.2507 23.0029 21.0557 23.058 20.0104 23.058C19.0052 23.058 18.8801 23.0329 18.6251 22.7629L18.475 22.6028L18.46 21.5226C18.445 20.4523 18.445 20.4473 18.5651 20.2623C18.6901 20.0772 18.9451 19.9122 19.1152 19.9072C19.1852 19.9072 19.2002 19.9522 19.2002 20.2073Z" :fill="$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'"/>
                </g>
                <defs>
                  <clipPath id="clip0_999_28870">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.657227)"/>
                  </clipPath>
                </defs>
              </svg>
              <span :style="`color : ${$route.path === '/insurance/vendors' ? '#5A9AE8' : '#38485C'}`">Vendors</span>  
             
            </a>
          </li>
          <li class="sidebar link" v-if="viewNewInsurance === true && viewNewInsurancePendingDeclare === true">
            <a @click="toInsurancePendingDeclarePage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M5.55937 1.20745C4.25996 1.25225 3.60465 1.45389 3.06136 1.96917C2.57688 2.42845 2.33604 3.01655 2.23522 3.97711C2.18201 4.49239 2.18201 16.6912 2.23522 17.1813C2.33324 18.0775 2.54327 18.6263 2.94934 19.0604C3.36661 19.5085 3.88189 19.7493 4.67163 19.8698C5.04689 19.9286 6.27069 19.9678 7.76614 19.9678H9.01795V19.1556V18.3435H7.79415C6.25389 18.3407 5.1365 18.3043 4.80325 18.2455C4.06952 18.1139 3.9043 17.8506 3.83709 16.6968C3.80068 16.1059 3.80348 5.04969 3.83709 4.45319C3.8931 3.50103 4.01352 3.18457 4.39158 3.01655C4.65202 2.89893 4.95727 2.85972 5.86742 2.82612C6.9092 2.78691 12.5213 2.80931 12.8966 2.85412C13.8404 2.96614 14.0336 3.15937 14.1456 4.10313C14.1652 4.25995 14.182 5.52016 14.1904 7.46929L14.2044 10.5862H15.0137H15.8231V7.93137C15.8203 3.83428 15.7867 3.37501 15.431 2.64689C15.0502 1.86556 14.3864 1.42868 13.3419 1.27466C13.1766 1.24945 12.7202 1.21865 12.3253 1.20464C11.4964 1.17384 6.43032 1.17664 5.55937 1.20745Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M7.04897 5.62937L6.38526 6.27908L6.25644 6.16146C6.18643 6.09705 6.06041 6.01303 5.97359 5.97383C5.84197 5.91222 5.78876 5.90381 5.63193 5.91502C5.4163 5.93182 5.30708 5.97943 5.16706 6.12505C4.95982 6.33789 4.92902 6.73835 5.09424 6.9988C5.14185 7.07441 5.35189 7.30125 5.55912 7.50288C5.98199 7.91455 6.13322 8.00977 6.37126 8.00977C6.67651 8.00697 6.85854 7.86694 7.8443 6.86998C8.64524 6.05784 8.70965 5.96823 8.70965 5.67418C8.70965 5.48935 8.63963 5.29891 8.53322 5.1869C8.41 5.05527 8.26717 5.00206 7.98153 4.99086L7.71548 4.98246L7.04897 5.62937Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M9.73744 6.22874C9.28377 6.39117 9.06533 6.90366 9.26417 7.34333C9.33138 7.49455 9.4938 7.65418 9.65903 7.73539C9.78785 7.7998 9.79625 7.7998 11.0061 7.7998H12.2243L12.3671 7.72419C12.6471 7.57577 12.804 7.31812 12.804 7.00167C12.804 6.75243 12.7227 6.562 12.5463 6.40517C12.3111 6.19234 12.2803 6.18954 10.9809 6.18954C10.0987 6.19234 9.82146 6.20074 9.73744 6.22874Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M6.1694 9.85461C5.81374 9.97783 5.62891 10.2439 5.62891 10.6387C5.62891 10.8768 5.71292 11.0644 5.89215 11.2212C6.13859 11.4369 5.95656 11.4257 9.00347 11.4257C12.0392 11.4257 11.8711 11.4369 12.1064 11.2296C12.1848 11.1596 12.2576 11.0588 12.308 10.9468C12.3752 10.7956 12.3836 10.748 12.3724 10.5715C12.3556 10.3223 12.252 10.1151 12.0728 9.98063C11.8319 9.7958 11.9496 9.8014 8.99227 9.8014C6.49705 9.8042 6.30662 9.807 6.1694 9.85461Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M15.1369 12.8431C13.8711 13.0783 12.8685 13.6468 12.0284 14.6102C11.5215 15.1899 11.1322 15.9404 10.9418 16.7049C10.8466 17.083 10.813 17.321 10.7934 17.7607C10.7318 19.0545 11.1266 20.2671 11.9248 21.2585C12.1684 21.5609 12.6865 22.0482 12.9973 22.2695C13.4818 22.6139 14.1231 22.908 14.7168 23.0564C15.1761 23.1712 15.4141 23.1992 16.005 23.1992C16.4951 23.1992 16.5763 23.1936 16.6631 23.1488C16.904 23.0228 16.9992 22.8604 16.9992 22.5775C16.9992 22.4039 16.988 22.3675 16.9096 22.2471C16.7556 22.023 16.6855 22.0006 16.019 21.981C15.7026 21.9698 15.3749 21.9474 15.2909 21.9306C13.7171 21.6114 12.5297 20.4912 12.1208 18.9369C12.0368 18.6205 12.034 18.5868 12.0312 18.0072C12.0312 17.4751 12.0368 17.377 12.0928 17.1586C12.2944 16.3493 12.6361 15.736 13.1934 15.1815C13.647 14.7278 14.1763 14.3974 14.7588 14.2069C15.2181 14.0557 15.4225 14.0249 15.991 14.0221C16.4363 14.0221 16.5483 14.0305 16.7864 14.0837C17.5145 14.2517 18.1446 14.571 18.6935 15.0527C18.8419 15.1843 19.1556 15.5371 19.178 15.596C19.1808 15.61 18.9987 15.6296 18.7719 15.6408C18.5451 15.652 18.3182 15.6772 18.2734 15.694C18.1586 15.7416 18.0158 15.9096 17.9822 16.0384C17.9065 16.3101 17.999 16.6013 18.2062 16.7385L18.3238 16.817L19.1668 16.8254C19.9397 16.8338 20.0209 16.8282 20.1917 16.7777C20.637 16.6433 21.0067 16.2709 21.1439 15.8256C21.1943 15.6688 21.1999 15.5651 21.1999 14.8538C21.1999 13.9745 21.1943 13.9437 21.0291 13.7868C20.903 13.6692 20.8134 13.6384 20.5866 13.6384C20.427 13.6384 20.3794 13.6496 20.2701 13.7196C20.0909 13.8345 20.0293 13.9745 20.0069 14.3301L19.9873 14.613L19.6904 14.3133C19.528 14.1481 19.318 13.9577 19.2256 13.8849C18.5899 13.4004 17.9009 13.0811 17.0944 12.8935C16.7864 12.8235 16.7079 12.8151 16.061 12.8095C15.529 12.8011 15.3077 12.8095 15.1369 12.8431Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M6.1694 13.6606C5.81374 13.7866 5.62891 14.0527 5.62891 14.4475C5.62891 14.6856 5.71292 14.8732 5.89215 15.03C6.12739 15.2373 6.13299 15.2373 7.52202 15.2289C8.72062 15.2205 8.75423 15.2177 8.86345 15.1589C9.25551 14.9488 9.41794 14.4587 9.23031 14.0723C9.14349 13.9014 9.00627 13.767 8.82424 13.683C8.70102 13.627 8.64781 13.6242 7.50522 13.6186C6.41864 13.6102 6.30102 13.6158 6.1694 13.6606Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M20.3401 18.4102C20.0852 18.4914 19.9676 18.6538 19.8696 19.0627C19.7688 19.4856 19.8612 19.7656 20.144 19.9C20.4017 20.0204 20.6901 19.9728 20.8721 19.7796C21.0402 19.6004 21.169 18.9955 21.0906 18.7574C21.043 18.6118 20.8777 18.4606 20.7125 18.413C20.5473 18.3626 20.4941 18.3626 20.3401 18.4102Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M19.5052 20.1749C19.3736 20.2225 19.0768 20.5278 18.9563 20.7378C18.7939 21.0207 18.8695 21.3735 19.1328 21.5527C19.2868 21.6564 19.424 21.6844 19.6144 21.6452C19.7405 21.6172 19.7825 21.5892 19.9729 21.3931C20.3426 21.0123 20.4182 20.7406 20.239 20.4354C20.0989 20.1973 19.7685 20.0797 19.5052 20.1749Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
                <path d="M17.9707 21.4905C17.7383 21.5885 17.5059 21.7314 17.4302 21.8294C17.2118 22.115 17.3126 22.5855 17.6263 22.7367C17.8419 22.8431 18.0351 22.8235 18.3376 22.6723C18.7241 22.4791 18.8193 22.3783 18.8613 22.129C18.8921 21.9358 18.8305 21.7426 18.6933 21.6025C18.5 21.4121 18.2564 21.3729 17.9707 21.4905Z" :fill="$route.path === '/insurance/pending' ? '#4096EC' : '#38485C'"/>
              </svg>
              <span :style="`color : ${$route.path === '/insurance/pending' ? '#5A9AE8' : '#38485C'}`">Pending Declare</span>  
              <span class="badge badge-danger badge-order pb-1" v-if="pendingInsuranceCount != '0'">
                {{ pendingInsuranceCount }}
              </span>
            </a>
          </li>
          <li class="sidebar link" v-if="viewNewInsurance === true && viewNewInsuranceBatch === true">
            <a @click="toInsuranceBatchListPage" class='list-group-item bg-light link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 21 25" fill="none">
                <path d="M18.7022 6.44164L12.7878 3.9069C12.2847 3.69129 11.7153 3.69129 11.2122 3.9069L5.29778 6.44164C4.47855 6.79274 3.99051 7.64358 4.10106 8.528L4.71405 13.4319C4.9342 15.1931 5.81517 16.8049 7.1787 17.9412L10.7196 20.892C11.4613 21.51 12.5387 21.51 13.2804 20.892L16.8213 17.9412C18.1848 16.8049 19.0658 15.1931 19.286 13.4319L19.8989 8.528C20.0095 7.64358 19.5215 6.79274 18.7022 6.44164Z" :stroke="$route.path === '/insurance/batch' ? '#5A9AE8' : '#38485C'" stroke-width="2" stroke-linecap="round"/>
                <path d="M9 12.6572L11.5687 15.226C11.7918 15.4491 12.1633 15.4123 12.3383 15.1498L16 9.65723" :stroke="$route.path === '/insurance/batch' ? '#5A9AE8' : '#38485C'" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <span :style="`color : ${$route.path === '/insurance/batch' ? '#5A9AE8' : '#38485C'}`">Batch Insurance</span>  
              <span class="badge badge-danger badge-order" v-if="batchInsuranceCount != '0'">
                {{ batchInsuranceCount }}
              </span>
            </a>
          </li>
          <li class="sidebar link" v-if="viewNewInsurance === true">
            <a @click="toInsurancePolisListPage" class='list-group-item bg-light link'> 
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
                <path d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"/>
              </svg>
              <span :style="`color : ${$route.path === '/insurance/polis' ? '#5A9AE8' : '#38485C'}`">Polis List</span>  
            </a>
          </li>
        </ul>
      </div>
      <!-- -->
      <!-- END OF INSURANCE -->
      <!-- Partnership -->
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex link active" data-toggle="collapse" data-target="#collapsePartnership" v-if="route === 'partnership'  && (viewLessor === true || viewLessee === true || viewLesseeVerification === true)">
        <i class="fas fa-handshake"></i>
        <span class="menu-title">Partnership</span>
        <div class="right-arrow"><span class="badge badge-danger badge-order" v-if="pendingPartnership != '0'">{{ pendingPartnership }}</span><i class="fas fa-angle-down"></i></div>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex link" data-toggle="collapse" data-target="#collapsePartnership" v-else-if="route != 'partnership'  && (viewLessor === true || viewLessee === true)">
        <i class="fas fa-handshake"></i>
        <span class="menu-title">Partnership</span>
        <div class="right-arrow"><span class="badge badge-danger badge-order" v-if="pendingPartnership != '0'">{{ pendingPartnership }}</span><i class="fas fa-angle-down"></i></div>
      </a>
      <div id="collapsePartnership" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="route === 'partnership' && (viewLessor === true || viewLessee === true)">
        <ul>
          <li class="sidebar link" v-if="viewLessor === true"><a @click="toPage('/partnership/lessor')">Lessor</a></li>
          <li class="sidebar link" v-if="viewLessee === true"><a @click="toLesseePage">Lessee <span class="badge badge-danger badge-order pb-1" v-if="pendingCompany != '0'">{{ pendingCompany }}</span></a></li>
          <li class="sidebar link" v-if="viewLesseeVerification === true"><a @click="toVerificationPage">Verification <span class="badge badge-danger badge-order" v-if="pendingDocCompany != '0'">{{ pendingDocCompany }}</span></a></li>
          <li class="sidebar link" v-if="viewAdmin === true"><a @click="toAdminPage()">Admin</a></li>
          <li class="sidebar link" v-if="viewInsurance === true"><a @click="toInsurancePage()">Insurance</a></li>
        </ul>
      </div>
      <div id="collapsePartnership" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else-if="route != 'partnership' && (viewLessor === true || viewLessee === true || viewLesseeVerification === true)">
        <ul>
          <li class="sidebar link" v-if="viewLessor === true"><a @click="toPage('/partnership/lessor')">Lessor</a></li>
          <li class="sidebar link" v-if="viewLessee === true"><a @click="toLesseePage">Lessee <span class="badge badge-danger badge-order pb-1" v-if="pendingCompany != '0'">{{ pendingCompany }}</span></a></li>
          <li class="sidebar link" v-if="viewLesseeVerification === true"><a @click="toVerificationPage">Verification <span class="badge badge-danger badge-order" v-if="pendingDocCompany != '0'">{{ pendingDocCompany }}</span></a></li>
          <li class="sidebar link" v-if="viewAdmin === true"><a @click="toAdminPage()">Admin</a></li>
          <li class="sidebar link" v-if="viewInsurance === true"><a @click="toInsurancePage()">Insurance</a></li>
        </ul>
      </div>
      <!-- END OF PARTNERSHIP -->
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex link active" data-toggle="collapse" data-target="#collapseRiskManagement" v-if="route === 'risk-management'">
        <i class="fas fa-handshake"></i>
        <span class="menu-title">Risk Management</span>
        <div class="right-arrow"><span class="badge badge-danger badge-order"></span><i class="fas fa-angle-down"></i></div>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex link" data-toggle="collapse" data-target="#collapseRiskManagement" v-else-if="route != 'risk-management'">
        <i class="fas fa-handshake"></i>
        <span class="menu-title">Risk Management</span>
        <div class="right-arrow"><span class="badge badge-danger badge-order"></span><i class="fas fa-angle-down"></i></div>
      </a>
      <div id="collapseRiskManagement" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="route === 'risk-management'">
        <ul>
          <li class="sidebar link"><a @click="toPage('/risk-management/cek')">Cek Kredit</a></li>
          <li class="sidebar link"><a @click="toPage('/risk-management/history')">Riwayat Pengecekan</a></li>
        </ul>
      </div>
      <div id="collapseRiskManagement" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else-if="route != 'risk-management'">
        <ul>
          <li class="sidebar link"><a @click="toPage('/risk-management/cek')">Cek Kredit</a></li>
          <li class="sidebar link"><a @click="toPage('/risk-management/history')">Riwayat Pengecekan</a></li>
        </ul>
      </div>
      <!-- -->
      <div class="border-bottom-active" v-if="route === 'employee' && viewEmployee === true">
        <a class="list-group-item list-group-item-action bg-light link active" @click="toEmployeePage">
          <i class="fas fa-user-circle"></i>
          <span class="menu-title"> Employee </span>
        </a>
      </div>
      <div v-else-if="route != 'employee' && viewEmployee === true">
        <a class="list-group-item list-group-item-action bg-light link" @click="toEmployeePage">
          <i class="fas fa-user-circle"></i>
          <span class="menu-title">Employee</span>
        </a>
      </div>
      
      <!-- -->
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex link active" data-toggle="collapse" data-target="#collapseTag" v-if="route === 'tag' && viewTag === true">
        <i class="fas fa-link"></i>
        <span class="menu-title">Tag</span>
        <div class="right-arrow"><span class="badge badge-danger badge-order"></span><i class="fas fa-angle-down"></i></div>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light d-flex link" data-toggle="collapse" data-target="#collapseTag" v-else-if="route != 'tag' && viewTag === true">
        <i class="fas fa-link"></i>
        <span class="menu-title">Tag</span>
        <div class="right-arrow"><span class="badge badge-danger badge-order"></span><i class="fas fa-angle-down"></i></div>
      </a>
      <div id="collapseTag" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" v-if="route === 'tag'">
        <ul>
          <li class="sidebar link" v-if="viewOrderTag"><a @click="toOrderTagPage">Order Tag</a></li>
          <li class="sidebar link" v-if="viewLesseeTag"><a @click="toLesseeTagPage">Lessee Tag</a></li>
        </ul>
      </div>
      <div id="collapseTag" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-else-if="route != 'tag'">
        <ul>
          <li class="sidebar link" v-if="viewOrderTag"><a @click="toOrderTagPage">Order Tag</a></li>
          <li class="sidebar link" v-if="viewLesseeTag"><a @click="toLesseeTagPage">Lessee Tag</a></li>
        </ul>
      </div>
      <!-- -->

      <div class="border-bottom-active" v-if="route === 'short-url' && viewShortLink === true">
        <a class="list-group-item list-group-item-action bg-light link active border-bottom" @click="toPage('/short-url')">
          <i class="fas fa-link"></i>
          <span class="menu-title"> Short Url </span>
        </a>
      </div>
      <div v-else-if="route != 'short-url' && viewShortLink === true" class="border-bottom">
        <a class="list-group-item list-group-item-action bg-light link" @click="toPage('/short-url')">
          <i class="fas fa-link"></i>
          <span class="menu-title">Short Url</span>
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { ComponentGuard, permissionMixin } from "@/components/Permissions"

export default {
  name: 'Home',
  components: {
    ComponentGuard
  },
  mixins: [permissionMixin],
  data() {
    return {
      admin: "",
      permission: [],
      viewDashboard: false,
      viewOrder: false,
      viewQc: false,
      viewUnmatch: false,
      viewProduct: false,
      viewPartCompatibility: false,
      viewBatchNumber: false,
      viewPurchaseReceipt : false,
      viewStock: false,
      viewStockSummary: false,
      viewAssembly: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewLesseeVerification: false,
      viewAdmin: false,
      viewInsurance: false,
      viewEmployee: false,
      viewSparepart: false,
      viewProcure: false,
      viewInventorySparepart: false,
      viewInventoryProduct: false,
      viewAssembly: false,
      viewOrderlist: false,
      viewSettings: false,
      viewShortLink: false,
      viewInsurance: false,
      viewStock: false,
      viewTag:false,
      viewOrderTag:false,
      viewLesseeTag:false,
      viewInvoicing : false,
      viewPendingInvoice : false,
      viewInvoiceList : false,
      viewPaymentList : false,
      viewConfirmPayment : false,
      viewInvoiceIgnored : false,
      viewNewInsurance : false,
      viewNewInsuranceVendor : false,
      viewNewInsurancePendingDeclare : false,
      viewNewInsuranceBatch : false,
      viewChangeSparepart : false,
      viewLostItem : false,
      viewDisposal: false,
      viewService: false,
      expired: false,
      route: '',
      pendingComplain: 0,
      pendingCompany: 0,
      pendingDocCompany: 0,
      pendingPartnership: 0,
      pendingInvoiceCount : 0,
      openInvoiceCount : 0,
      pendingInsuranceCount : 0,
      polisInsuranceListCount : 0,
      batchInsuranceCount: 0,
      qc:0,
      unmatch:0,
      orderCount: 0,
      rentalCount: 0,
      rentAdjustmentCount: 0,
      productCount: 0,
    }
  },
  computed: {
    showOrderSubItem() {
      const route = this.$route.path.split('/')[1]
      const orderRoute = ['rent-adjustment', 'rental', 'order']
      return orderRoute.includes(route);
    }
  },
  methods: {
    toPurchaseReceipt() {
      this.$router.push({
        path: '/purchase/receipt',
        query: {
            poId : '',
            supplierName : '',
            createdDate : '',
            status : '',
            page : 1,
            itemPerPage : 10,
        }
      })
    },
    toChangeSparepartPage() {
      this.$router.push({
        path: '/assembly/sparepart-change'
      })
    },
    toOrderTagPage() {
       this.$router.push({path:'/tag/order', query: {
            tagName: '',
            tagCategory: JSON.stringify([]),
            categoryName: '',
            page:1,
            categoryPage: 1
          }
      })
    },
    toLesseeTagPage() {
       this.$router.push({path:'/tag/lessee', query: {
            tagName: '',
            tagCategory: JSON.stringify([]),
            categoryName: '',
            page:1,
            categoryPage: 1
          }
      })
    },
    toEmployeePage(){
      this.$router.push({path:'/employee/search', query: {
            employeeName: "",
            employeeEmail: "",
            userType: "",
            division: "",
            page:1
          }
      })
    },
    showWarehouseInventoryMenu() {
      // return (route === 'inventory' || route === 'orderlist' || route === 'assembly') && (viewInventorySparepart === true || viewInventoryProduct === true || viewAssembly === true || viewOrderlist === true || viewSettings === true)
      return process.env.ENABLE_INVENTORY
    },
    toChangeSpecPage() {
      this.$router.push({
        path: '/assembly/change-spec'
      })
    },
    toFixUnitPage() {
      this.$router.push({
        path: '/assembly/perbaikan'
      })
    },
    toUpdateInfoPage() {
      this.$router.push({
        path: '/assembly/updateInfo'
      })
    },
    toInsurancePage() {
      this.$router.push({
        path: '/partnership/insurance',
        query: {
          lesseeName: '',
          orderCode: '',
          startRent: '',
          endRent: '',
          productName: '',
          productCode: '',
          insuranceStatus: JSON.stringify([]),
          page: 1,
          itemPerPage: 10
        }
      })
    },
    toOrderListPage() {
      this.$router.push({
        path: '/orderlist',
        query: {
          sku: '',
          type: 'All',
          typeName: 'All',
          sparepartName: 'All',
          page: 1,
          itemPerPage: 10,
        }
      })
    },
    toInventoryProductPage() {
      this.$router.push({
        path: '/inventory/product',
        query: {
          warehouseId: 'All',
          warehouseName: 'All',
          productId: '',
          type: 'All',
          name: '',
          criteria: 0,
          page: 1,
          itemPerPage: 10,
        }
      })
    },
    toInventorySparepartPage() {
      this.$router.push({
        path: '/inventory/sparepart',
        query: {
          warehouseId: 'All',
          warehouseName: 'All',
          sku: '',
          type: 'All',
          name: '',
          criteria: 0,
          page: 1,
          itemPerPage: 10,
        }
      })
    },
    // toProcurePage() {
    //   this.$router.push({
    //     path: '/procure',
    //     query: {
    //       procureId: '',
    //       requestTime: 'All',
    //       employeeName: 'All',
    //       employeeId: 'All',
    //       status: 'All',
    //       statusName: 'All',
    //       page: 1,
    //       itemPerPage: 10,
    //     }
    //   })
    // },
    toSparepartPage() {
      this.$router.push({
        path: '/sparepart',
        query: {
          sku: '',
          type: 'All',
          name: '',
          page: 1,
          itemPerPage: 10,
        }
      })
    },
    toProductPage() {
      this.$toCatalogProduct(this.$router)
    },
    toPartCompabilityPage() {
      this.$router.push({path:'/catalog/part-compatibility',
            query: {
                partName:'',
                itemCode: '',
                status: 0,
                itemPerPage: 10,
                page:1
            }
        })
    },
    toBatchNumberListPage() {
      this.$router.push({
        path: '/catalog/batch-number-list',
        query: {
          batchNumber: '',
          sn: '',
          noItem: '',
          source : null,
          itemName : '',
          page: 1,
          itemPerPage: 10,
        }
      })
    },
    toLesseePage() {
      this.$router.push({
        path: '/partnership/lessee',
        query: {
          companyName: '',
          statusLessee: JSON.stringify([]),
          salesStatus: JSON.stringify([]),
          picLessee: JSON.stringify([]),
          joinLesseeFrom: '',
          joinLesseeTo: '',
          page: 1
        }
      })
    },
    toProductCatalogPage() {
      this.$router.push({
        path: '/product',
        query: {
          productType: 'All',
          productTypeName: 'All',
          productCategory: 'All',
          productBrand: 'All',
          productStatus: 'All',
          productStatusName: 'All',
          productName: '',
          itemPerPage: 10,
          page: 1
        }
      })
    },
    toOrderPage() {
      this.$router.push({
        path: '/order',
        query: {
          companyName: '',
          orderId: '',
          statusOrder: JSON.stringify([]),
          picId: 'All',
          picName: 'All',
          startRentFrom: '',
          startRentTo: '',
          endRentFrom: '',
          endRentTo: '',
          itemPerPage: 10,
          tagOrder: JSON.stringify([]),
          batch: '',
          sortBy:'',
          page: 1
        }
      })
    },
    toVerificationPage() {
      this.$router.push({
        path: '/partnership/lessee/verification',
        query: {
          companyName: '',
          verificationStatus: 'All',
          page: 1
        }
      })
    },
    toReturnPage(type) {
      if (type == 'qc') {
        this.$router.push({
          path: '/return/quality-control',
          query: {
            uniqueId: '',
            tipe : 'All',
            itemPerPage: 10,
            page: 1
          }
        })
      } else if (type == 'up') {
        this.$router.push('/return/unmatch')
      }
    },
    toStockPage() {
      this.$router.push({
        path: '/stock/product',
        query: {
          page: 1,
          itemPerPage: 10,
          type: '',
          name: ''
        }
      })
    },
    toStockSummaryPage() {
      this.$router.push({
        path: '/stock/summary'
      })
    },
    toAdminPage() {
      this.$router.push({
        path: '/partnership/admin',
        query: {
          companyName: '',
          lesseeType: 'All',
          lesseeTypeName: 'All',
          lesseeName: '',
          lesseePhone: '',
          lesseeEmail: '',
          lesseeStatus: 'All',
          lesseeStatusName: 'All',
          page: 1,
          itemPerPage : 10,
        }
      })
    },
    toDisposalPage() {
      this.$router.push({
        path: '/disposal',
        query: {
          disposalId: '',
          disposalDate: '',
          createdBy: '',
          erpTrxId: '',
          jurnalTrxId: '',
          status: '',
          page: 1,
          itemPerPage: 10,
        }
      })
    },
    toResolutionPage() {
      this.$router.push({
        path: '/resolution',
        query: {
          ticketNumber: '',
          companyId: '',
          companyName: 'All',
          productCode: '',
          picName: '',
          technicianName: '',
          statusComplain: JSON.stringify([]),
          page: 1
        }
      })
    },
    toServicePage() {
      this.$router.push({
        path: '/service',
        query: {
          serviceId: '',
          vendorName: '',
          createdDate: '',
          createdBy: '',
          status: '',
          itemPerPage:10,
          page: 1
        }
      })
    },
    toRentalProductPage() {
      this.$router.push({
        path: '/rental/product',
        query: {
          companyName: '',
          productBrand: 'All',
          productModel: 'All',
          productCode: '',
          productType: 'All',
          productTypeName: 'All',
          productStatus: 'All',
          productStatusName: 'All',
          startRentFrom: '',
          startRentTo: '',
          endRentFrom: '',
          endRentTo: '',
          itemPerPage: 10,
          page: 1
        }
      })
    },
    toTransferUnitPage() {
      this.$router.push({
          path: '/rent-adjustment',
          query: {
            orderId: "",
            productCode: "",
            tipe: "",
            status: "",
            firstLessee: "",
            targetLessee: "",
            dateFrom: "",
            dateTo: "",
            itemPerPage: 10,
            page: 1
          }
      })
    },
    toPage(e) {
      if (e == '/product') {
        localStorage.setItem('itemPerPage', 10)
      }
      localStorage.removeItem('endrent_cache')
      localStorage.removeItem('qc-cache')
      this.$router.push(e)
    },
    // to Invoicing page
    toInvoicePendingPage() {
      this.$router.push({
        path: '/invoicing/pending',
        query: {
          companyName: '',
          companyId:'',
          billingCycleStart: '',
          billingCycleEnd : '',
          page: 1,
          itemPerPage : 10,
          invoiceNumber: '',
          jurnalStatus : '',
          jurnalStatusName : '',
          orderId : '',
        }
      })
    },
    toInvoiceListPage() {
      this.$router.push({
        path: '/invoicing/list',
         query: {
          companyName: '',
          companyId : '',
          page: 1,
          itemPerPage : 10,
          invoiceStatus : '',
          invoiceStatusName : '',
          invoiceNumber: '',
          jurnalStatus : '',
          jurnalStatusName : '',
          orderId : '',
        }
      })
    },
    toInvoicePaymentListPage() {
      this.$router.push({
        path: '/invoicing/payments',
        // query: {
        //   companyName: '',
        //   statusLessee: JSON.stringify([]),
        //   salesStatus: JSON.stringify([]),
        //   picLessee: JSON.stringify([]),
        //   joinLesseeFrom: '',
        //   joinLesseeTo: '',
        //   page: 1
        // }
      })
    },
    toInvoicePaymentConfirmationPage() {
      this.$router.push({
        path: '/invoicing/confirm-payment',
        // query: {
        //   companyName: '',
        //   statusLessee: JSON.stringify([]),
        //   salesStatus: JSON.stringify([]),
        //   picLessee: JSON.stringify([]),
        //   joinLesseeFrom: '',
        //   joinLesseeTo: '',
        //   page: 1
        // }
      })
    },
    toInvoiceIgnoreListPage() {
      this.$router.push({
        path: '/invoicing/ignore',
        query: {
          companyName: '',
          companyId:'',
          billingCycleStart: '',
          billingCycleEnd : '',
          page: 1,
          itemPerPage : 10,
          invoiceNumber: '',
          orderId : '',
          jurnalStatus : '',
          jurnalStatusName : '',
        }
      })
    },
    // to Insurance Page
    toInsuranceVendorPage() {
      this.$router.push({
        path: '/insurance/vendors',
        query: {
          vendorName: '',
          page: 1,
          itemPerPage: 10
        }
      })
    },
    toInsurancePendingDeclarePage() {
      this.$router.push({
        path: '/insurance/pending',
        query: {
          page: 1,
          itemPerPage: 10,
          batchOrder:'',
          orderCode: '',
          lesseeName: '',
          productCode: '',
          startRentFrom : '',
          startRentTo : '',
          endRentFrom : '',
          endRentTo : '',
          status: 'Pending',
        }
      })
    },
    toInsuranceBatchListPage() {
      this.$router.push({
        path: '/insurance/batch',
        query: {
          batchOrder: "",
          status: "",
          startDateDeclare: "",
          endDateDeclare: "",
          partnerName: "",
          page: 1,
          itemPerPage: 10
        }
      })
    },
    toInsurancePolisListPage() {
        this.$router.push({
        path: '/insurance/polis',
        query: {
          page: 1,
          itemPerPage: 10,
          orderCode: '',
          lesseeName: '',
          productCode: '',
          startRentFrom : '',
          startRentTo : '',
          endRentFrom : '',
          endRentTo : '',
          declaredDateFrom : '',
          declaredDateTo : '',
        }
      })
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true
        }
        if (["2.1", "13.1", "2.6", "27.1"].includes(this.permission[i])) {
          this.viewOrder = true
        }
        if(this.permission[i] == '2.7') {
          this.viewLostItem = true
        }
        if (this.permission[i] == '3.1') {
          this.viewQc = true
        }
        if (this.permission[i] == '4.1') {
          this.viewProduct = true
          this.viewStock = process.env.ENABLE_INSURANCE
        }

        if (this.permission[i] == '4.5') {
          this.viewPartCompatibility = true
        }

        if(this.permission[i] == '25.1') {
          this.viewPurchaseReceipt = true
        }
        if(this.permission[i] == '4.9') {
          this.viewBatchNumber = true
        }
        if (this.permission[i] == '5.1') {
          this.viewPairing = true
        }
        if (this.permission[i] == '6') {
          this.viewReconcile = true
        }
        if (this.permission[i] == '7.1') {
          this.viewResolution = true
        }
        if (this.permission[i] == '8.1') {
          this.viewLessor = true
        }
        if (this.permission[i] == '9.1') {
          this.viewLessee = true
        }
        if (this.permission[i] == '11.1') {
          this.viewLesseeVerification = true
        }
        if (this.permission[i] == '12.1') {
          this.viewStock = true
        }
        if (this.permission[i] == '10.1') {
          this.viewEmployee = true
        }
        if (this.permission[i] == '14.1') {
          this.viewAdmin = true
        }
        if (this.permission[i] == '15.1') {
          this.viewInsurance = process.env.ENABLE_INSURANCE
        }
        if (this.permission[i] == '17') {
          this.viewShortLink = process.env.ENABLE_SHORT_LINK
        }
        if (this.permission[i] == '18') {
          this.viewProcure = true
        }
        if (this.permission[i] == '19') {
          this.viewStockSummary = true
        }
         if (["20.1", "20.3"].includes(this.permission[i])) {
          this.viewTag = true
        }
        if (this.permission[i] == '20.1') {
          this.viewOrderTag = true
        }
        if (this.permission[i] == '20.3') {
          this.viewLesseeTag = true
        }
        if (this.permission[i] == '16' || this.permission[i] == '16.1' || this.permission[i] == '16.2') {
          this.viewUnmatch = true
        }
        if(["21.1", "21.2", "21.3", "21.4", "21.5"].includes(this.permission[i])) {
          this.viewInvoicing = true
        }
         if(this.permission[i] == '21.1') {
          this.viewPendingInvoice = true
        }
         if(this.permission[i] == '21.2') {
          this.viewInvoiceList = true
        }
         if(this.permission[i] == '21.3') {
          this.viewPaymentList = true
        }
         if(this.permission[i] == '21.4') {
          this.viewConfirmPayment = true
        }
        if(this.permission[i] == '21.5') {
          this.viewInvoiceIgnored = true
        }
        if(['22','22.1', '22.2', '22.3'].includes(this.permission[i])) {
          this.viewNewInsurance = true
        }
        if(this.permission[i] == '22.1') {
          this.viewNewInsuranceVendor = true
        }
        if(this.permission[i] == '22.2') {
          this.viewNewInsurancePendingDeclare = true
        }
        if(this.permission[i] == '22.3') {
          this.viewNewInsuranceBatch = true
        }
        // if(this.permission[i] == '24') {
          // this.viewAssembly = true
        // }
        if(this.permission[i] == '24.1') {
          this.viewChangeSparepart = true
        }
        if(this.permission[i] == '26.1') {
          this.viewDisposal = true
        }
        if(this.permission[i] == '27.1') {
          this.viewService = true
        }

        this.viewSparepart = true
        this.viewInventorySparepart = process.env.ENABLE_INVENTORY
        this.viewInventoryProduct = process.env.ENABLE_INVENTORY
        this.viewAssembly = process.env.ENABLE_INVENTORY
        this.viewOrderlist = process.env.ENABLE_INVENTORY
        this.viewSettings = process.env.ENABLE_INVENTORY
      }
    },
    charCount(str, letter) {
      var letter_Count = 0;
      for (var position = 0; position < str.length; position++) {
        if (str.charAt(position) == letter) {
          letter_Count += 1;
        }
      }
      return letter_Count;
    },
    getRoute() {
      var jml = this.charCount(this.$route.path, '/')
      if (jml == 1) {
        this.route = this.$route.path.replace('/', '');
      } else {
        this.route = this.$route.path.substring(
          this.$route.path.indexOf("/") + 1,
          this.$route.path.indexOf("/", 2)
        )
      }
    },
    getBadgeCount() {
      this.$http.get(process.env.BADGE_COUNT, {
          timeout : 300 * 1000,
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
      .then((response) => {
        if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })

          } else {
            this.pendingComplain = response.data.data.ticket.count
            this.pendingCompany = response.data.data.lessee.count
            this.pendingDocCompany = response.data.data.verif.count
            this.pendingPartnership = this.pendingCompany + this.pendingDocCompany
            this.qc = response.data.data.return_qc.count
            this.unmatch = response.data.data.return_unmatch.count
            this.orderCount = response.data.data.rental_order.count
            this.rentAdjustmentCount = response.data.data.lease.count
            if (this.hasPermission({requiredPermissions: ['2.1']})) {
              this.rentalCount += response.data.data.rental_order.count
            }
            if (this.hasPermission({requiredPermissions: ['27.1']})) {
              this.rentalCount += response.data.data.lease.count
            }
            // this.productCount = response.data.content.product_order.count
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })

      this.$http.get(process.env.GET_INVOICE_BADGE_COUNT, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
      .then((response) => {
        if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })

          } else {
            this.pendingInvoiceCount = response.data.data.pendingInvoice
            this.openInvoiceCount =  response.data.data.openInvoice
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })

        this.$http.post(process.env.GET_INSURANCE_BADGE_COUNT,{}, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then((response) => {
          if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Ok",
              })
 
          } else {
              this.pendingInsuranceCount = response.data.data.pendingDashboard
              this.polisInsuranceListCount =  response.data.data.polisList
              this.batchInsuranceCount = response.data.data.batchDashboard
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    toRentalUpgrade() {
      this.$router.push('/rental/upgrade')
    },
    toLostItemPage() {
      this.$router.push({
        path : '/lost-item',
        query: {
          page: 1,
          itemPerPage: 10,
          companyName: '',
          productName: '',
          orderId: '',
          status: 'All',
        }
      })
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    notifyMe() {
      // Let's check if the browser supports notifications
      if (!("Notification" in window)) {
        console.log("This browser does not support desktop notification");
      }
      // Let's check whether notification permissions have alredy been granted
      else if (Notification.permission === "granted") {}
      // Otherwise, we need to ask the user for permission
      else if (Notification.permission !== 'denied' || Notification.permission === "default") {
        Notification.requestPermission(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === "granted") {
            // var notification = new Notification("Hi there!");
          }
        });
      }
    },
    connectNotification: function () {
      var ws = new WebSocket('wss://' + process.env.WS_URL + '/ws/notification-orders/receive');
      ws.onopen = function () {
        // ws.send(JSON.stringify({
        //   "command": "show-notes",
        //   "token": localStorage.getItem('jwt')
        //     //.... some message the I must send when I connect ....
        // }));
      }
      var dataLog = []
      var admin = this.admin
      var jml = this.charCount(this.$route.path, '/')
      var route
      if (jml == 1) {
        route = this.$route.path.replace('/', '');
      } else {
        route = this.$route.path.substring(
          this.$route.path.indexOf("/") + 1,
          this.$route.path.indexOf("/", 2)
        )
      }
      var self = this;
      ws.addEventListener('message', function (e) {
        // console.log(JSON.parse(e.data))
        if (JSON.parse(e.data).status != 101) {
          var n = new Notification('Hallo ' + admin, {
            body: 'New order from ' + JSON.parse(e.data).companyName + ' qty ' + JSON.parse(e.data).qty,
            icon: 'https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_brand/mini+logo.jpg',
            renotify: false
            // image: 'https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_invoice/asani.png'
          });
          var urlOrder = window.location.href.substring(0, window.location.href.indexOf(route))
          setTimeout(n.close.bind(n), 60000);
          n.onclick = function (event) {
            event.preventDefault();
            window.open(urlOrder + 'order', '_blank');
          }
        }
      })
      ws.onclose = function (e) {
        setTimeout(function () {
          self.connectNotification()
        }, 1000);
      };
      ws.onerror = function (err) {
        console.error('Socket encountered error: ', err.message, 'Closing socket');
        ws.close();
      };
    },
  },
  async created() {
    if(this.$route.path !== '/return/quality-control') {
      localStorage.removeItem('qc-cache')
    }
    if(this.$route.path !== '/risk-management/history') {
      localStorage.removeItem('history-cache')
    } if(this.$route.path !== '/rental/upgrade') {
      localStorage.removeItem('upgrade-cache')
    }
    this.admin = localStorage.getItem('admin_name')
    this.cekPermission()
    this.notifyMe()
    this.getRoute()
    this.getBadgeCount()
    // this.connectNotification()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.sidebar.link a {
  padding-right: 10px;
}
.badge-order {
  border-radius: 50%;
  /*margin-left: 15px;*/
  margin-top: 4px;
  margin-right: 5px;
}
.badge-resolution {
  border-radius: 50%;
  /*margin-left: 15px;*/
  float: right;
  margin-top: 4px;
}
.border-bottom {
  border-bottom: 1px solid #007bff;
}
.border-bottom-active {
  border-bottom: 1px solid #007bff;
}
.active {
  color: #2797FB;
}
.list-group-item.active {
  color: #2797FB;
}
.right-dropdown {
  margin-left: 7px;
}
.account-div {
  margin: 2px 2px;
}
.right-arrow {
  margin-left: auto;
}
.brand-logo {
  width: 120px;
}
.menu-title {
  margin-left: 1.125rem;
}
.menu-title-order {
  margin-left: 1.6rem;
}
.menu-title-payment {
  margin-left: 1.6rem;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}
li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}
li a.active {
  background-color: #4CAF50;
  color: white;
}
li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}
.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}
.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}
.nav-side-menu .toggle-btn {
  display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
  /*    
    .collapsed{
       .arrow:before{
                 font-family: FontAwesome;
                 content: "\f053";
                 display: inline-block;
                 padding-left:10px;
                 padding-right: 10px;
                 vertical-align: middle;
                 float:right;
            }
     }
     */
}
.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}
@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Layout/Navigation/Sidebar.vue